(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[2826],{

/***/ 19895:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ button_button)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/styled-components.js
var styled_components = __webpack_require__(39391);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/utils.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function getSharedProps(_ref) {
  var disabled = _ref.disabled,
      isLoading = _ref.isLoading,
      isSelected = _ref.isSelected,
      kind = _ref.kind,
      shape = _ref.shape,
      size = _ref.size;
  return {
    $disabled: disabled,
    $isLoading: isLoading,
    $isSelected: isSelected,
    $kind: kind,
    $shape: shape,
    $size: size
  };
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js
var react_is = __webpack_require__(99415);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(72221);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/button-internals.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/






function RenderEnhancer(props) {
  var Enhancer = props.Enhancer,
      restProps = _objectWithoutProperties(props, ["Enhancer"]);

  if (typeof Enhancer === 'string') {
    return Enhancer;
  }

  if (react_is.isValidElementType(Enhancer)) {
    // $FlowFixMe
    return /*#__PURE__*/react.createElement(Enhancer, restProps);
  } // $FlowFixMe


  return Enhancer;
}

function ButtonInternals(props) {
  var children = props.children,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      startEnhancer = props.startEnhancer,
      endEnhancer = props.endEnhancer;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.StartEnhancer, styled_components/* StartEnhancer */.mI),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      StartEnhancer = _getOverrides2[0],
      startEnhancerProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.EndEnhancer, styled_components/* EndEnhancer */.XU),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      EndEnhancer = _getOverrides4[0],
      endEnhancerProps = _getOverrides4[1];

  var sharedProps = getSharedProps(props);
  return /*#__PURE__*/react.createElement(react.Fragment, null, startEnhancer !== null && startEnhancer !== undefined && /*#__PURE__*/react.createElement(StartEnhancer, _extends({}, sharedProps, startEnhancerProps), /*#__PURE__*/react.createElement(RenderEnhancer, {
    Enhancer: startEnhancer
  })), children, endEnhancer !== null && endEnhancer !== undefined && /*#__PURE__*/react.createElement(EndEnhancer, _extends({}, sharedProps, endEnhancerProps), /*#__PURE__*/react.createElement(RenderEnhancer, {
    Enhancer: endEnhancer
  })));
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/constants.js
var constants = __webpack_require__(67710);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/default-props.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var defaultProps = {
  disabled: false,
  isLoading: false,
  isSelected: false,
  kind: constants/* KIND */.TO.primary,
  overrides: {},
  shape: constants/* SHAPE */.X3.default,
  size: constants/* SIZE */.NO.default
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/utils/focusVisible.js
var focusVisible = __webpack_require__(27247);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/button.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function button_extends() { button_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return button_extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function button_slicedToArray(arr, i) { return button_arrayWithHoles(arr) || button_iterableToArrayLimit(arr, i) || button_unsupportedIterableToArray(arr, i) || button_nonIterableRest(); }

function button_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function button_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return button_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return button_arrayLikeToArray(o, minLen); }

function button_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function button_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function button_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function button_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = button_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function button_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/








var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocusVisible: false
    });

    _defineProperty(_assertThisInitialized(_this), "internalOnClick", function () {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          onClick = _this$props.onClick;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (isLoading) {
        args[0].preventDefault();
        return;
      }

      onClick && onClick.apply(void 0, args);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if ((0,focusVisible/* isFocusVisible */.E)(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _ref;

      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          size = _this$props2.size,
          kind = _this$props2.kind,
          shape = _this$props2.shape,
          isLoading = _this$props2.isLoading,
          isSelected = _this$props2.isSelected,
          startEnhancer = _this$props2.startEnhancer,
          endEnhancer = _this$props2.endEnhancer,
          children = _this$props2.children,
          forwardedRef = _this$props2.forwardedRef,
          restProps = button_objectWithoutProperties(_this$props2, ["overrides", "size", "kind", "shape", "isLoading", "isSelected", "startEnhancer", "endEnhancer", "children", "forwardedRef"]); // Get overrides


      var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)( // adding both (1) BaseButton and (2) Root
      // (1) because it's a Button under the hood
      // (2) because we want consistency with the rest of the components
      overrides.BaseButton || overrides.Root, styled_components/* BaseButton */.Yd),
          _getOverrides2 = button_slicedToArray(_getOverrides, 2),
          BaseButton = _getOverrides2[0],
          baseButtonProps = _getOverrides2[1];

      var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.LoadingSpinner, styled_components/* LoadingSpinner */.TK),
          _getOverrides4 = button_slicedToArray(_getOverrides3, 2),
          LoadingSpinner = _getOverrides4[0],
          loadingSpinnerProps = _getOverrides4[1];

      var _getOverrides5 = (0,helpers_overrides/* getOverrides */.jb)(overrides.LoadingSpinnerContainer, styled_components/* LoadingSpinnerContainer */.dx),
          _getOverrides6 = button_slicedToArray(_getOverrides5, 2),
          LoadingSpinnerContainer = _getOverrides6[0],
          loadingSpinnerContainerProps = _getOverrides6[1];

      var sharedProps = _objectSpread(_objectSpread({}, getSharedProps(this.props)), {}, {
        $isFocusVisible: this.state.isFocusVisible
      });

      return /*#__PURE__*/react.createElement(BaseButton, button_extends({
        ref: forwardedRef,
        "data-baseweb": "button"
      }, isLoading ? (_ref = {}, _defineProperty(_ref, 'aria-label', "loading ".concat(typeof this.props.children === 'string' ? this.props.children : '')), _defineProperty(_ref, 'aria-busy', 'true'), _ref) : {}, sharedProps, restProps, baseButtonProps, {
        // Applies last to override passed in onClick
        onClick: this.internalOnClick,
        onFocus: (0,focusVisible/* forkFocus */.Ah)(_objectSpread(_objectSpread({}, restProps), baseButtonProps), this.handleFocus),
        onBlur: (0,focusVisible/* forkBlur */.Z5)(_objectSpread(_objectSpread({}, restProps), baseButtonProps), this.handleBlur)
      }), isLoading ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        style: {
          opacity: 0,
          display: 'flex',
          height: '0px'
        }
      }, /*#__PURE__*/react.createElement(ButtonInternals, this.props)), /*#__PURE__*/react.createElement(LoadingSpinnerContainer, button_extends({}, sharedProps, loadingSpinnerContainerProps), /*#__PURE__*/react.createElement(LoadingSpinner, button_extends({}, sharedProps, loadingSpinnerProps)))) : /*#__PURE__*/react.createElement(ButtonInternals, this.props));
    }
  }]);

  return Button;
}(react.Component);

_defineProperty(Button, "defaultProps", defaultProps);

var ForwardedButton = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/react.createElement(Button, button_extends({
    forwardedRef: ref
  }, props));
});
ForwardedButton.displayName = 'Button';
/* harmony default export */ const button_button = (ForwardedButton);

/***/ }),

/***/ 67710:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NO: () => (/* binding */ SIZE),
/* harmony export */   TO: () => (/* binding */ KIND),
/* harmony export */   X3: () => (/* binding */ SHAPE)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var KIND = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  minimal: 'minimal'
};
var SHAPE = {
  default: 'default',
  pill: 'pill',
  round: 'round',
  circle: 'circle',
  square: 'square'
};
var SIZE = {
  mini: 'mini',
  default: 'default',
  compact: 'compact',
  large: 'large'
};

/***/ }),

/***/ 39391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TK: () => (/* binding */ LoadingSpinner),
/* harmony export */   XU: () => (/* binding */ EndEnhancer),
/* harmony export */   Yd: () => (/* binding */ BaseButton),
/* harmony export */   dx: () => (/* binding */ LoadingSpinnerContainer),
/* harmony export */   mI: () => (/* binding */ StartEnhancer)
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67710);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var BaseButton = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('button', function (_ref) {
  var $theme = _ref.$theme,
      $size = _ref.$size,
      $kind = _ref.$kind,
      $shape = _ref.$shape,
      $isLoading = _ref.$isLoading,
      $isSelected = _ref.$isSelected,
      $disabled = _ref.$disabled,
      $isFocusVisible = _ref.$isFocusVisible;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    display: 'inline-flex',
    // need to maintain button width while showing loading spinner
    flexDirection: $isLoading ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    outline: 'none',
    boxShadow: $isFocusVisible ? "inset 0 0 0 3px ".concat($theme.colors.accent) : 'none',
    textDecoration: 'none',
    WebkitAppearance: 'none',
    transitionProperty: 'background',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.linearCurve,
    cursor: 'pointer',
    ':disabled': {
      cursor: 'not-allowed',
      backgroundColor: $theme.colors.buttonDisabledFill,
      color: $theme.colors.buttonDisabledText
    },
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0
  }, getFontStyles({
    $theme: $theme,
    $size: $size
  })), getBorderRadiiStyles({
    $theme: $theme,
    $size: $size,
    $shape: $shape
  })), getPaddingStyles({
    $theme: $theme,
    $size: $size,
    $shape: $shape
  })), getKindStyles({
    $theme: $theme,
    $kind: $kind,
    $isLoading: $isLoading,
    $isSelected: $isSelected,
    $disabled: $disabled
  })), getShapeStyles({
    $theme: $theme,
    $shape: $shape,
    $size: $size
  }));
});
BaseButton.displayName = "BaseButton";
var EndEnhancer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref2) {
  var $theme = _ref2.$theme;
  var marginDirection = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _defineProperty({
    display: 'flex'
  }, marginDirection, $theme.sizing.scale500);
});
EndEnhancer.displayName = "EndEnhancer";
var StartEnhancer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref4) {
  var $theme = _ref4.$theme;
  var marginDirection = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _defineProperty({
    display: 'flex'
  }, marginDirection, $theme.sizing.scale500);
});
StartEnhancer.displayName = "StartEnhancer";
var LoadingSpinnerContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref6) {
  var $theme = _ref6.$theme,
      $size = _ref6.$size;
  // we don't have a theming value for this
  var margins = '3px';

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.mini || $size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.compact) {
    margins = $theme.sizing.scale0;
  }

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.large) {
    margins = $theme.sizing.scale100;
  }

  return {
    lineHeight: 0,
    position: 'static',
    marginBottom: margins,
    marginTop: margins
  };
});
LoadingSpinnerContainer.displayName = "LoadingSpinnerContainer";
var LoadingSpinner = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('span', function (_ref7) {
  var $theme = _ref7.$theme,
      $kind = _ref7.$kind,
      $disabled = _ref7.$disabled,
      $size = _ref7.$size;

  var _getLoadingSpinnerCol = getLoadingSpinnerColors({
    $theme: $theme,
    $kind: $kind,
    $disabled: $disabled
  }),
      foreground = _getLoadingSpinnerCol.foreground,
      background = _getLoadingSpinnerCol.background;

  var dimension = $theme.sizing.scale550;

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.mini || $size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.compact) {
    dimension = $theme.sizing.scale500;
  }

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.large) {
    dimension = $theme.sizing.scale600;
  }

  return {
    height: dimension,
    width: dimension,
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%',
    borderLeftStyle: 'solid',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftWidth: $theme.sizing.scale0,
    borderTopWidth: $theme.sizing.scale0,
    borderRightWidth: $theme.sizing.scale0,
    borderBottomWidth: $theme.sizing.scale0,
    borderTopColor: foreground,
    borderLeftColor: background,
    borderBottomColor: background,
    borderRightColor: background,
    boxSizing: 'border-box',
    display: 'inline-block',
    animationDuration: $theme.animation.timing700,
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationName: {
      to: {
        transform: 'rotate(360deg)'
      },
      from: {
        transform: 'rotate(0deg)'
      }
    }
  };
});
LoadingSpinner.displayName = "LoadingSpinner";

function getLoadingSpinnerColors(_ref8) {
  var $theme = _ref8.$theme,
      $kind = _ref8.$kind,
      $disabled = _ref8.$disabled;

  if ($disabled) {
    return {
      foreground: $theme.colors.buttonDisabledSpinnerForeground,
      background: $theme.colors.buttonDisabledSpinnerBackground
    };
  }

  switch ($kind) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.secondary:
      {
        return {
          foreground: $theme.colors.buttonSecondarySpinnerForeground,
          background: $theme.colors.buttonSecondarySpinnerBackground
        };
      }

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.tertiary:
      {
        return {
          foreground: $theme.colors.buttonTertiarySpinnerForeground,
          background: $theme.colors.buttonTertiarySpinnerBackground
        };
      }

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.minimal:
      {
        return {
          foreground: $theme.colors.buttonMinimalSpinnerForeground,
          background: $theme.colors.buttonMinimalSpinnerBackground
        };
      }

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.primary:
    default:
      {
        return {
          foreground: $theme.colors.buttonPrimarySpinnerForeground,
          background: $theme.colors.buttonPrimarySpinnerBackground
        };
      }
  }
}

function getBorderRadiiStyles(_ref9) {
  var $theme = _ref9.$theme,
      $size = _ref9.$size,
      $shape = _ref9.$shape;
  var value = $theme.borders.buttonBorderRadius;

  if ($shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.pill) {
    if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.compact) {
      value = '30px';
    } else if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.large) {
      value = '42px';
    } else {
      value = '38px';
    }
  } else if ($shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.circle || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.round) {
    value = '50%';
  }

  return {
    borderTopRightRadius: value,
    borderBottomRightRadius: value,
    borderTopLeftRadius: value,
    borderBottomLeftRadius: value
  };
}

function getFontStyles(_ref10) {
  var $theme = _ref10.$theme,
      $size = _ref10.$size;

  switch ($size) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.mini:
      return $theme.typography.font150;

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.compact:
      return $theme.typography.font250;

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.large:
      return $theme.typography.font450;

    default:
      return $theme.typography.font350;
  }
}

function getPaddingStyles(_ref11) {
  var $theme = _ref11.$theme,
      $size = _ref11.$size,
      $shape = _ref11.$shape;
  var iconShape = $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.square || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.circle || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.round;

  switch ($size) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.mini:
      return {
        paddingTop: $theme.sizing.scale200,
        paddingBottom: $theme.sizing.scale200,
        paddingLeft: iconShape ? $theme.sizing.scale200 : $theme.sizing.scale300,
        paddingRight: iconShape ? $theme.sizing.scale200 : $theme.sizing.scale300
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.compact:
      return {
        paddingTop: $theme.sizing.scale400,
        paddingBottom: $theme.sizing.scale400,
        paddingLeft: iconShape ? $theme.sizing.scale400 : $theme.sizing.scale500,
        paddingRight: iconShape ? $theme.sizing.scale400 : $theme.sizing.scale500
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.large:
      return {
        paddingTop: $theme.sizing.scale600,
        paddingBottom: $theme.sizing.scale600,
        paddingLeft: iconShape ? $theme.sizing.scale600 : $theme.sizing.scale700,
        paddingRight: iconShape ? $theme.sizing.scale600 : $theme.sizing.scale700
      };

    default:
      return {
        paddingTop: $theme.sizing.scale550,
        paddingBottom: $theme.sizing.scale550,
        paddingLeft: iconShape ? $theme.sizing.scale550 : $theme.sizing.scale600,
        paddingRight: iconShape ? $theme.sizing.scale550 : $theme.sizing.scale600
      };
  }
}

function getKindStyles(_ref12) {
  var $theme = _ref12.$theme,
      $isLoading = _ref12.$isLoading,
      $isSelected = _ref12.$isSelected,
      $kind = _ref12.$kind,
      $disabled = _ref12.$disabled;

  if ($disabled) {
    return Object.freeze({});
  }

  switch ($kind) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.primary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonPrimarySelectedText,
          backgroundColor: $theme.colors.buttonPrimarySelectedFill
        };
      }

      return {
        color: $theme.colors.buttonPrimaryText,
        backgroundColor: $theme.colors.buttonPrimaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonPrimaryActive : $theme.colors.buttonPrimaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonPrimaryActive
        }
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.secondary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonPrimaryText,
          backgroundColor: $theme.colors.buttonPrimaryFill
        };
      }

      return {
        color: $theme.colors.buttonSecondaryText,
        backgroundColor: $theme.colors.buttonSecondaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonSecondaryActive : $theme.colors.buttonSecondaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonSecondaryActive
        }
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.tertiary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonTertiarySelectedText,
          backgroundColor: $theme.colors.buttonTertiarySelectedFill
        };
      }

      return {
        color: $theme.colors.buttonTertiaryText,
        backgroundColor: $theme.colors.buttonTertiaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonTertiaryActive : $theme.colors.buttonTertiaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonTertiaryActive
        }
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .TO.minimal:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonMinimalSelectedText,
          backgroundColor: $theme.colors.buttonMinimalSelectedFill
        };
      }

      return {
        color: $theme.colors.buttonMinimalText,
        backgroundColor: $theme.colors.buttonMinimalFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonMinimalActive : $theme.colors.buttonMinimalHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonMinimalActive
        }
      };

    default:
      return Object.freeze({});
  }
}

function getShapeStyles(_ref13) {
  var $theme = _ref13.$theme,
      $shape = _ref13.$shape,
      $size = _ref13.$size;

  if ($shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.circle || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .X3.square) {
    var height, width;

    switch ($size) {
      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.mini:
        height = '28px';
        width = '28px';
        break;

      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.compact:
        height = '36px';
        width = '36px';
        break;

      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.large:
        height = '56px';
        width = '56px';
        break;

      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .NO.default:
      default:
        height = '48px';
        width = '48px';
        break;
    }

    return {
      height: height,
      width: width,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    };
  } else {
    return {};
  }
}

/***/ }),

/***/ 24747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: () => (/* binding */ Consumer),
/* harmony export */   ZP: () => (/* binding */ LayersManager),
/* harmony export */   rH: () => (/* binding */ LayersContext)
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72221);
/* harmony import */ var _utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27247);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




var StyledAppContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('div', {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('div', {});
StyledLayersContainer.displayName = "StyledLayersContainer";

function defaultEventHandlerFn() {
  if (false) {}
}

var LayersContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: undefined,
  zIndex: undefined
});
var Provider = LayersContext.Provider;
var Consumer = LayersContext.Consumer;

var LayersManager = /*#__PURE__*/function (_React$Component) {
  _inherits(LayersManager, _React$Component);

  var _super = _createSuper(LayersManager);

  function LayersManager(props) {
    var _this;

    _classCallCheck(this, LayersManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "host", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createRef());

    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createRef());

    _defineProperty(_assertThisInitialized(_this), "onDocumentClick", function (event) {
      var docClickHandler = _this.state.docClickHandlers[_this.state.docClickHandlers.length - 1];

      if (docClickHandler) {
        docClickHandler(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      if (event.key === 'Escape') {
        var escapeKeyHandler = _this.state.escapeKeyHandlers[_this.state.escapeKeyHandlers.length - 1];

        if (escapeKeyHandler) {
          escapeKeyHandler();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAddEscapeHandler", function (escapeKeyHandler) {
      _this.setState(function (prev) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray(prev.escapeKeyHandlers), [escapeKeyHandler])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveEscapeHandler", function (escapeKeyHandler) {
      _this.setState(function (prev) {
        return {
          escapeKeyHandlers: prev.escapeKeyHandlers.filter(function (handler) {
            return handler !== escapeKeyHandler;
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddDocClickHandler", function (docClickHandler) {
      _this.setState(function (prev) {
        return {
          docClickHandlers: [].concat(_toConsumableArray(prev.docClickHandlers), [docClickHandler])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveDocClickHandler", function (docClickHandler) {
      _this.setState(function (prev) {
        return {
          docClickHandlers: prev.docClickHandlers.filter(function (handler) {
            return handler !== docClickHandler;
          })
        };
      });
    });

    _this.state = {
      escapeKeyHandlers: [],
      docClickHandlers: []
    };
    return _this;
  }

  _createClass(LayersManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate();
      (0,_utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_2__/* .initFocusVisible */ .L)(this.containerRef.current);

      if (typeof document !== 'undefined') {
        document.addEventListener('keyup', this.onKeyUp); // using mousedown event so that callback runs before events on children inside of the layer

        document.addEventListener('mousedown', this.onDocumentClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('mousedown', this.onDocumentClick);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_3__/* .getOverrides */ .jb)(overrides.AppContainer, StyledAppContainer),
          _getOverrides2 = _slicedToArray(_getOverrides, 2),
          AppContainer = _getOverrides2[0],
          appContainerProps = _getOverrides2[1];

      var _getOverrides3 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_3__/* .getOverrides */ .jb)(overrides.LayersContainer, StyledLayersContainer),
          _getOverrides4 = _slicedToArray(_getOverrides3, 2),
          LayersContainer = _getOverrides4[0],
          layersContainerProps = _getOverrides4[1];

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Consumer, null, function (_ref) {
        var host = _ref.host;

        if (false) {}

        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Provider, {
          value: {
            host: host || _this2.host.current,
            zIndex: _this2.props.zIndex,
            addEscapeHandler: _this2.onAddEscapeHandler,
            removeEscapeHandler: _this2.onRemoveEscapeHandler,
            addDocClickHandler: _this2.onAddDocClickHandler,
            removeDocClickHandler: _this2.onRemoveDocClickHandler
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContainer, _extends({}, appContainerProps, {
          ref: _this2.containerRef
        }), _this2.props.children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(LayersContainer, _extends({}, layersContainerProps, {
          ref: _this2.host
        })));
      });
    }
  }]);

  return LayersManager;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);



/***/ }),

/***/ 92539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ createDarkTheme)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/animation.js
var animation = __webpack_require__(30889);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/borders.js
var borders = __webpack_require__(23112);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/utils/deep-merge.js
var deep_merge = __webpack_require__(69176);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/borders.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


// Override border colors for the dark theme
var borders_borders = (0,deep_merge/* default */.Z)({}, borders/* default */.Z, {
  border100: {
    borderColor: 'hsla(0, 0%, 100%, 0.04)'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 100%, 0.08)'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 100%, 0.12)'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 100%, 0.16)'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 100%, 0.2)'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 100%, 0.24)'
  }
});
/* harmony default export */ const dark_theme_borders = (borders_borders);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/breakpoints.js
var breakpoints = __webpack_require__(1687);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/tokens/colors.js
var colors = __webpack_require__(99749);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-tokens.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// color constants
var darkColorTokens = {
  // Primary Palette
  primaryA: colors/* default */.Z.gray200,
  primaryB: colors/* default */.Z.gray900,
  primary: colors/* default */.Z.white,
  primary50: colors/* default */.Z.gray50,
  primary100: colors/* default */.Z.gray100,
  primary200: colors/* default */.Z.gray200,
  primary300: colors/* default */.Z.gray300,
  primary400: colors/* default */.Z.gray400,
  primary500: colors/* default */.Z.gray500,
  primary600: colors/* default */.Z.gray600,
  primary700: colors/* default */.Z.gray700,
  // Accent Palette
  accent: colors/* default */.Z.blue400,
  accent50: colors/* default */.Z.blue50,
  accent100: colors/* default */.Z.blue100,
  accent200: colors/* default */.Z.blue200,
  accent300: colors/* default */.Z.blue300,
  accent400: colors/* default */.Z.blue400,
  accent500: colors/* default */.Z.blue500,
  accent600: colors/* default */.Z.blue600,
  accent700: colors/* default */.Z.blue700,
  // Negative Palette
  negative: colors/* default */.Z.red500,
  negative50: colors/* default */.Z.red50,
  negative100: colors/* default */.Z.red100,
  negative200: colors/* default */.Z.red200,
  negative300: colors/* default */.Z.red300,
  negative400: colors/* default */.Z.red400,
  negative500: colors/* default */.Z.red500,
  negative600: colors/* default */.Z.red600,
  negative700: colors/* default */.Z.red700,
  // Warning Palette
  warning: colors/* default */.Z.yellow500,
  warning50: colors/* default */.Z.yellow50,
  warning100: colors/* default */.Z.yellow100,
  warning200: colors/* default */.Z.yellow200,
  warning300: colors/* default */.Z.yellow300,
  warning400: colors/* default */.Z.yellow400,
  warning500: colors/* default */.Z.yellow500,
  warning600: colors/* default */.Z.yellow600,
  warning700: colors/* default */.Z.yellow700,
  // Positive Palette
  positive: colors/* default */.Z.green400,
  positive50: colors/* default */.Z.green50,
  positive100: colors/* default */.Z.green100,
  positive200: colors/* default */.Z.green200,
  positive300: colors/* default */.Z.green300,
  positive400: colors/* default */.Z.green400,
  positive500: colors/* default */.Z.green500,
  positive600: colors/* default */.Z.green600,
  positive700: colors/* default */.Z.green700,
  // Monochrome Palette
  white: colors/* default */.Z.white,
  black: colors/* default */.Z.black,
  mono100: colors/* default */.Z.gray300,
  mono200: colors/* default */.Z.gray400,
  mono300: colors/* default */.Z.gray500,
  mono400: colors/* default */.Z.gray600,
  mono500: colors/* default */.Z.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: '#292929',
  mono700: '#1F1F1F',
  mono800: '#141414',
  mono900: '#111111',
  mono1000: colors/* default */.Z.black,
  // Rating Palette,
  rating200: colors/* default */.Z.yellow200,
  rating400: colors/* default */.Z.yellow400,
  ratingInactiveFill: colors/* default */.Z.gray500,
  ratingStroke: colors/* default */.Z.gray700
};
/* harmony default export */ const color_tokens = (darkColorTokens);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-component-tokens.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var tagHoverBackground = "rgba(255, 255, 255, 0.2)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the values
// need to be overrideable through primitives

/* harmony default export */ const color_component_tokens = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color_tokens;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.black,
    buttonPrimaryHover: themePrimitives.primary100,
    buttonPrimaryActive: themePrimitives.primary200,
    buttonPrimarySelectedText: themePrimitives.black,
    buttonPrimarySelectedFill: themePrimitives.primary200,
    buttonPrimarySpinnerForeground: themePrimitives.primary700,
    buttonPrimarySpinnerBackground: themePrimitives.primary300,
    buttonSecondaryFill: themePrimitives.primary700,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary600,
    buttonSecondaryActive: themePrimitives.primary500,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySelectedFill: themePrimitives.primary500,
    buttonSecondarySpinnerForeground: themePrimitives.white,
    buttonSecondarySpinnerBackground: themePrimitives.primary400,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary700,
    buttonTertiaryActive: themePrimitives.primary600,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiarySelectedFill: themePrimitives.primary600,
    buttonTertiarySpinnerForeground: themePrimitives.primary50,
    buttonTertiarySpinnerBackground: themePrimitives.primary500,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary700,
    buttonMinimalActive: themePrimitives.primary600,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSelectedFill: themePrimitives.primary600,
    buttonMinimalSpinnerForeground: themePrimitives.primary50,
    buttonMinimalSpinnerBackground: themePrimitives.primary500,
    buttonDisabledFill: themePrimitives.mono600,
    buttonDisabledText: themePrimitives.mono300,
    buttonDisabledSpinnerForeground: themePrimitives.mono200,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono100,
    breadcrumbsSeparatorFill: themePrimitives.mono200,
    // Datepicker
    datepickerBackground: themePrimitives.mono600,
    datepickerDayFont: themePrimitives.white,
    datepickerDayFontDisabled: themePrimitives.mono100,
    datepickerDayPseudoSelected: themePrimitives.mono500,
    datepickerDayPseudoHighlighted: themePrimitives.mono600,
    // Calendar
    calendarBackground: themePrimitives.mono800,
    calendarForeground: themePrimitives.white,
    calendarForegroundDisabled: themePrimitives.mono300,
    calendarHeaderBackground: themePrimitives.primary700,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary600,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary700,
    calendarDayForegroundPseudoSelected: themePrimitives.primary,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary600,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.primary,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.black,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary100,
    calendarDayForegroundSelectedHighlighted: themePrimitives.black,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono600,
    comboboxListItemHover: themePrimitives.mono500,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono700,
    fileUploaderBackgroundColorActive: themePrimitives.mono600,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono100,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary100,
    linkHover: themePrimitives.primary200,
    linkActive: themePrimitives.primary300,
    // List
    listHeaderFill: themePrimitives.mono600,
    listBodyFill: themePrimitives.mono700,
    listIconFill: themePrimitives.mono100,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.black,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.black,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Modal
    modalCloseColor: themePrimitives.mono300,
    modalCloseColorHover: themePrimitives.mono400,
    modalCloseColorFocus: themePrimitives.mono400,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary700,
    notificationPrimaryText: themePrimitives.primary200,
    notificationInfoBackground: themePrimitives.accent700,
    notificationInfoText: themePrimitives.accent200,
    notificationPositiveBackground: themePrimitives.positive700,
    notificationPositiveText: themePrimitives.positive200,
    notificationWarningBackground: themePrimitives.warning700,
    notificationWarningText: themePrimitives.warning200,
    notificationNegativeBackground: themePrimitives.negative700,
    notificationNegativeText: themePrimitives.negative200,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '600',
    tagOutlinedDisabledRampUnit: '700',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '500',
    tagOutlinedFontRampUnit: '500',
    tagOutlinedRampUnit: '500',
    // Deprecated
    tagSolidHoverRampUnit: '500',
    tagSolidActiveRampUnit: '400',
    tagSolidDisabledRampUnit: '700',
    tagSolidFontHoverRampUnit: '100',
    tagLightRampUnit: '700',
    tagLightHoverRampUnit: '700',
    tagLightActiveRampUnit: '600',
    tagLightDisabledRampUnit: '700',
    tagLightFontRampUnit: '100',
    tagLightFontHoverRampUnit: '100',
    tagOutlinedActiveRampUnit: '300',
    tagOutlinedHoverRampUnit: '800',
    tagOutlinedFontHoverRampUnit: '100',
    // Neutral
    tagNeutralOutlinedFont: themePrimitives.mono100,
    tagNeutralOutlinedBackground: themePrimitives.mono200,
    tagNeutralSolidFont: themePrimitives.black,
    tagNeutralSolidBackground: themePrimitives.primary200,
    // not much we can do to get the correct gray here
    tagNeutralFontDisabled: themePrimitives.mono400,
    tagNeutralOutlinedDisabled: themePrimitives.mono500,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono600,
    tagNeutralSolidActive: themePrimitives.mono500,
    tagNeutralSolidDisabled: themePrimitives.mono700,
    tagNeutralSolidFontHover: themePrimitives.mono200,
    tagNeutralLightBackground: themePrimitives.mono800,
    tagNeutralLightHover: themePrimitives.mono800,
    tagNeutralLightActive: themePrimitives.mono700,
    tagNeutralLightDisabled: themePrimitives.mono700,
    tagNeutralLightFont: themePrimitives.mono200,
    tagNeutralLightFontHover: themePrimitives.mono200,
    tagNeutralOutlinedActive: themePrimitives.mono400,
    tagNeutralOutlinedFontHover: themePrimitives.mono100,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryOutlinedFont: themePrimitives.primary200,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    tagPrimarySolidFont: themePrimitives.black,
    tagPrimarySolidBackground: themePrimitives.primary200,
    tagPrimaryFontDisabled: themePrimitives.primary600,
    tagPrimaryOutlinedDisabled: themePrimitives.primary700,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary700,
    tagPrimarySolidActive: themePrimitives.primary400,
    tagPrimarySolidDisabled: themePrimitives.primary700,
    tagPrimarySolidFontHover: themePrimitives.primary100,
    tagPrimaryLightBackground: themePrimitives.primary700,
    tagPrimaryLightHover: themePrimitives.primary700,
    tagPrimaryLightActive: themePrimitives.primary600,
    tagPrimaryLightDisabled: themePrimitives.primary700,
    tagPrimaryLightFont: themePrimitives.primary100,
    tagPrimaryLightFontHover: themePrimitives.primary100,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedFontHover: themePrimitives.primary200,
    tagPrimaryOutlinedHover: tagHoverBackground,
    // Accent
    tagAccentOutlinedFont: themePrimitives.accent200,
    tagAccentOutlinedBackground: themePrimitives.accent500,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent500,
    tagAccentFontDisabled: themePrimitives.accent600,
    tagAccentOutlinedDisabled: themePrimitives.accent700,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent500,
    tagAccentSolidActive: themePrimitives.accent400,
    tagAccentSolidDisabled: themePrimitives.accent700,
    tagAccentSolidFontHover: themePrimitives.accent100,
    tagAccentLightBackground: themePrimitives.accent700,
    tagAccentLightHover: themePrimitives.accent700,
    tagAccentLightActive: themePrimitives.accent600,
    tagAccentLightDisabled: themePrimitives.accent700,
    tagAccentLightFont: themePrimitives.accent100,
    tagAccentLightFontHover: themePrimitives.accent100,
    tagAccentOutlinedActive: themePrimitives.accent300,
    tagAccentOutlinedFontHover: themePrimitives.accent200,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveOutlinedFont: themePrimitives.positive300,
    tagPositiveOutlinedBackground: themePrimitives.positive500,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive500,
    tagPositiveFontDisabled: themePrimitives.positive600,
    tagPositiveOutlinedDisabled: themePrimitives.positive700,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive500,
    tagPositiveSolidActive: themePrimitives.positive400,
    tagPositiveSolidDisabled: themePrimitives.positive700,
    tagPositiveSolidFontHover: themePrimitives.positive100,
    tagPositiveLightBackground: themePrimitives.positive700,
    tagPositiveLightHover: themePrimitives.positive700,
    tagPositiveLightActive: themePrimitives.positive600,
    tagPositiveLightDisabled: themePrimitives.positive700,
    tagPositiveLightFont: themePrimitives.positive100,
    tagPositiveLightFontHover: themePrimitives.positive100,
    tagPositiveOutlinedActive: themePrimitives.positive300,
    tagPositiveOutlinedFontHover: themePrimitives.positive300,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningOutlinedFont: themePrimitives.warning300,
    tagWarningOutlinedBackground: themePrimitives.warning500,
    tagWarningSolidFont: themePrimitives.black,
    tagWarningSolidBackground: themePrimitives.warning500,
    tagWarningFontDisabled: themePrimitives.warning600,
    tagWarningOutlinedDisabled: themePrimitives.warning700,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning500,
    tagWarningSolidActive: themePrimitives.warning400,
    tagWarningSolidDisabled: themePrimitives.warning700,
    tagWarningSolidFontHover: themePrimitives.warning100,
    tagWarningLightBackground: themePrimitives.warning700,
    tagWarningLightHover: themePrimitives.warning700,
    tagWarningLightActive: themePrimitives.warning600,
    tagWarningLightDisabled: themePrimitives.warning700,
    tagWarningLightFont: themePrimitives.warning100,
    tagWarningLightFontHover: themePrimitives.warning100,
    tagWarningOutlinedActive: themePrimitives.warning300,
    tagWarningOutlinedFontHover: themePrimitives.warning300,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeOutlinedFont: themePrimitives.negative300,
    tagNegativeOutlinedBackground: themePrimitives.negative500,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative500,
    tagNegativeFontDisabled: themePrimitives.negative600,
    tagNegativeOutlinedDisabled: themePrimitives.negative700,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative500,
    tagNegativeSolidActive: themePrimitives.negative400,
    tagNegativeSolidDisabled: themePrimitives.negative700,
    tagNegativeSolidFontHover: themePrimitives.negative100,
    tagNegativeLightBackground: themePrimitives.negative700,
    tagNegativeLightHover: themePrimitives.negative700,
    tagNegativeLightActive: themePrimitives.negative600,
    tagNegativeLightDisabled: themePrimitives.negative700,
    tagNegativeLightFont: themePrimitives.negative100,
    tagNegativeLightFontHover: themePrimitives.negative100,
    tagNegativeOutlinedActive: themePrimitives.negative300,
    tagNegativeOutlinedFontHover: themePrimitives.negative300,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono700,
    tableBackground: themePrimitives.mono800,
    tableStripedBackground: themePrimitives.mono700,
    tableFilter: themePrimitives.mono400,
    tableFilterHeading: themePrimitives.mono300,
    tableFilterBackground: themePrimitives.mono700,
    tableFilterFooterBackground: themePrimitives.mono800,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary500,
    toastInfoBackground: themePrimitives.accent500,
    toastPositiveBackground: themePrimitives.positive500,
    toastWarningBackground: themePrimitives.warning500,
    toastNegativeBackground: themePrimitives.negative500,
    // Toggle
    toggleFill: themePrimitives.mono300,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono700,
    // Tick
    tickFill: themePrimitives.mono1000,
    tickFillHover: themePrimitives.mono700,
    tickFillActive: themePrimitives.mono600,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary50,
    tickFillSelectedHoverActive: themePrimitives.primary100,
    tickFillError: themePrimitives.negative700,
    tickFillErrorHover: themePrimitives.negative600,
    tickFillErrorHoverActive: themePrimitives.negative500,
    tickFillErrorSelected: themePrimitives.negative500,
    tickFillErrorSelectedHover: themePrimitives.negative600,
    tickFillErrorSelectedHoverActive: themePrimitives.negative700,
    tickFillDisabled: themePrimitives.mono500,
    tickBorder: themePrimitives.mono300,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.black,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono800,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary500,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderHandleFillHover: themePrimitives.mono300,
    sliderHandleFillActive: themePrimitives.mono300,
    sliderHandleFillSelected: themePrimitives.primary500,
    sliderHandleFillSelectedHover: themePrimitives.primary600,
    sliderHandleFillSelectedActive: themePrimitives.primary700,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono400,
    sliderTrackFillSelected: themePrimitives.primary500,
    sliderTrackFillSelectedActive: themePrimitives.primary600,
    sliderTrackFillSelectedHover: themePrimitives.primary700,
    sliderTrackFillDisabled: themePrimitives.mono700,
    sliderHandleInnerFillDisabled: themePrimitives.mono500,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary600,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary700,
    sliderBorder: themePrimitives.white,
    sliderBorderHover: themePrimitives.white,
    sliderBorderDisabled: themePrimitives.mono400,
    // Input
    inputBorder: themePrimitives.mono600,
    inputFill: themePrimitives.mono600,
    inputFillActive: themePrimitives.mono500,
    inputFillError: themePrimitives.negative700,
    inputFillDisabled: themePrimitives.mono800,
    inputFillPositive: themePrimitives.positive700,
    inputTextDisabled: themePrimitives.mono500,
    inputBorderError: themePrimitives.negative400,
    inputBorderPositive: themePrimitives.positive400,
    inputEnhancerFill: themePrimitives.mono500,
    inputEnhancerFillDisabled: themePrimitives.mono700,
    inputEnhancerTextDisabled: themePrimitives.mono500,
    inputPlaceholder: themePrimitives.mono300,
    inputPlaceholderDisabled: themePrimitives.mono500,
    // Menu
    menuFill: themePrimitives.mono600,
    menuFillHover: themePrimitives.mono700,
    menuFontDefault: themePrimitives.mono300,
    menuFontDisabled: themePrimitives.mono400,
    menuFontHighlighted: themePrimitives.white,
    menuFontSelected: themePrimitives.white,
    // Pagination
    paginationTriangleDown: themePrimitives.mono100,
    // Header navigation
    headerNavigationFill: themePrimitives.mono700,
    // Tab
    tabBarFill: themePrimitives.mono1000,
    tabColor: themePrimitives.mono300,
    // Spinner
    spinnerTrackFill: themePrimitives.mono100,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono100,
    // Tooltip
    tooltipBackground: themePrimitives.mono200,
    tooltipText: themePrimitives.mono1000
  };
});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-deprecated-semantic-tokens.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


/* ---- DEPRECATED ---- */
/* harmony default export */ const color_deprecated_semantic_tokens = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color_tokens;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.mono100,
    colorSecondary: themePrimitives.mono200,
    // Background
    background: themePrimitives.mono1000,
    backgroundAlt: themePrimitives.mono700,
    backgroundInv: themePrimitives.mono100,
    // Foreground
    foreground: themePrimitives.mono100,
    foregroundAlt: themePrimitives.mono300,
    foregroundInv: themePrimitives.mono1000,
    // Borders
    border: themePrimitives.mono600,
    borderAlt: themePrimitives.mono700,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
});
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/util.js
var util = __webpack_require__(9471);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-semantic-tokens.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



/* harmony default export */ const color_semantic_tokens = (function () {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color_tokens;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: colors/* default */.Z.gray800,
    backgroundTertiary: colors/* default */.Z.gray700,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: colors/* default */.Z.gray300,
    // Content
    contentPrimary: foundation.primaryA,
    contentSecondary: colors/* default */.Z.gray400,
    contentTertiary: colors/* default */.Z.gray500,
    contentInversePrimary: foundation.primaryB,
    contentInverseSecondary: colors/* default */.Z.gray600,
    contentInverseTertiary: colors/* default */.Z.gray500,
    // Border
    borderOpaque: colors/* default */.Z.gray700,
    borderTransparent: (0,util/* hexToRgb */.oo)(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: colors/* default */.Z.gray400,
    borderInverseTransparent: (0,util/* hexToRgb */.oo)(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: colors/* default */.Z.gray800,
    backgroundOverlayDark: (0,util/* hexToRgb */.oo)(colors/* default */.Z.black, '0.3'),
    backgroundOverlayLight: (0,util/* hexToRgb */.oo)(colors/* default */.Z.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: foundation.positive,
    backgroundLightAccent: colors/* default */.Z.blue700,
    backgroundLightPositive: colors/* default */.Z.green700,
    backgroundLightNegative: colors/* default */.Z.red700,
    backgroundLightWarning: colors/* default */.Z.yellow700,
    backgroundAlwaysDark: colors/* default */.Z.gray900,
    backgroundAlwaysLight: colors/* default */.Z.gray100,
    // Content
    contentStateDisabled: colors/* default */.Z.gray600,
    contentAccent: colors/* default */.Z.blue300,
    contentOnColor: colors/* default */.Z.white,
    contentOnColorInverse: colors/* default */.Z.black,
    contentNegative: colors/* default */.Z.red300,
    contentWarning: colors/* default */.Z.yellow300,
    contentPositive: colors/* default */.Z.green300,
    // Border
    borderStateDisabled: colors/* default */.Z.gray800,
    borderAccent: colors/* default */.Z.blue400,
    borderAccentLight: colors/* default */.Z.blue500,
    borderNegative: colors/* default */.Z.red500,
    borderWarning: colors/* default */.Z.yellow500,
    borderPositive: colors/* default */.Z.green500
  };
  return _objectSpread(_objectSpread({}, core), coreExtensions);
});
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/typography.js
var typography = __webpack_require__(86081);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/grid.js
var grid = __webpack_require__(67755);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/lighting.js
var lighting = __webpack_require__(63131);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/media-query.js
var media_query = __webpack_require__(84025);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/sizing.js
var sizing = __webpack_require__(57049);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/create-dark-theme.js
function create_dark_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function create_dark_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { create_dark_theme_ownKeys(Object(source), true).forEach(function (key) { create_dark_theme_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { create_dark_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function create_dark_theme_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/













function createDarkTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = create_dark_theme_objectSpread(create_dark_theme_objectSpread({}, color_tokens), customColorTokens);

  var theme = {
    animation: animation/* default */.Z,
    borders: dark_theme_borders,
    breakpoints: breakpoints/* default */.Z,
    colors: create_dark_theme_objectSpread(create_dark_theme_objectSpread(create_dark_theme_objectSpread(create_dark_theme_objectSpread({}, colorTokens), color_component_tokens(colorTokens)), color_deprecated_semantic_tokens(colorTokens)), color_semantic_tokens(colorTokens)),
    direction: 'auto',
    grid: grid/* default */.Z,
    lighting: lighting/* default */.Z,
    mediaQuery: media_query/* default */.Z,
    sizing: sizing/* default */.Z,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? (0,typography/* default */.Z)({
      primaryFontFamily: primaryFontFamily
    }) : (0,typography/* default */.Z)(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return (0,deep_merge/* default */.Z)({}, theme, overrides);
}

/***/ }),

/***/ 70531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ createLightTheme)
/* harmony export */ });
/* harmony import */ var _shared_animation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30889);
/* harmony import */ var _shared_borders_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23112);
/* harmony import */ var _shared_breakpoints_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1687);
/* harmony import */ var _utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69176);
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43258);
/* harmony import */ var _color_component_tokens_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43579);
/* harmony import */ var _color_deprecated_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10482);
/* harmony import */ var _color_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80217);
/* harmony import */ var _shared_typography_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86081);
/* harmony import */ var _shared_grid_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67755);
/* harmony import */ var _shared_lighting_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63131);
/* harmony import */ var _shared_media_query_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84025);
/* harmony import */ var _shared_sizing_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57049);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/













function createLightTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = _objectSpread(_objectSpread({}, _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), customColorTokens);

  var theme = {
    animation: _shared_animation_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    borders: _shared_borders_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    breakpoints: _shared_breakpoints_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colorTokens), (0,_color_component_tokens_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(colorTokens)), (0,_color_deprecated_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(colorTokens)), (0,_color_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(colorTokens)),
    direction: 'auto',
    grid: _shared_grid_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    lighting: _shared_lighting_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
    mediaQuery: _shared_media_query_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
    sizing: _shared_sizing_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? (0,_shared_typography_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
      primaryFontFamily: primaryFontFamily
    }) : (0,_shared_typography_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return (0,_utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, theme, overrides);
}

/***/ }),

/***/ 77379:
/***/ ((module) => {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 11928:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(24007),
    last = __webpack_require__(77875),
    parent = __webpack_require__(83744),
    toKey = __webpack_require__(86040);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 70492:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPlainObject = __webpack_require__(54256);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 33273:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var flatten = __webpack_require__(62923),
    overRest = __webpack_require__(20340),
    setToString = __webpack_require__(4173);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 83744:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(40548),
    baseSlice = __webpack_require__(77379);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 73352:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(29233),
    baseClone = __webpack_require__(18361),
    baseUnset = __webpack_require__(11928),
    castPath = __webpack_require__(24007),
    copyObject = __webpack_require__(78618),
    customOmitClone = __webpack_require__(70492),
    flatRest = __webpack_require__(33273),
    getAllKeysIn = __webpack_require__(55713);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 25438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Qj: () => (/* reexport */ ObserverComponent),
  Pi: () => (/* reexport */ observer),
  fv: () => (/* reexport */ useLocalObservable)
});

// UNUSED EXPORTS: _observerFinalizationRegistry, clearTimers, enableStaticRendering, isObserverBatched, isUsingStaticRendering, observerBatching, useAsObservableSource, useLocalStore, useObserver, useStaticRendering

// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(28786);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/assertEnvironment.js


if (!react.useState) {
    throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!mobx_esm.makeObservable) {
    throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
}
//# sourceMappingURL=assertEnvironment.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(5556);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js

//# sourceMappingURL=reactBatchedUpdates.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/observerBatching.js

function defaultNoopBatch(callback) {
    callback();
}
function observerBatching(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = defaultNoopBatch;
        if (false) {}
    }
    (0,mobx_esm.configure)({ reactionScheduler: reactionScheduler });
}
var isObserverBatched = function () {
    if (false) {}
    return true;
};
//# sourceMappingURL=observerBatching.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/printDebugValue.js

function printDebugValue(v) {
    return (0,mobx_esm.getDependencyTree)(v);
}
//# sourceMappingURL=printDebugValue.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/staticRendering.js
var globalIsUsingStaticRendering = false;
function staticRendering_enableStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}
//# sourceMappingURL=staticRendering.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/UniversalFinalizationRegistry.js
var REGISTRY_FINALIZE_AFTER = 10000;
var REGISTRY_SWEEP_INTERVAL = 10000;
var TimerBasedFinalizationRegistry = /** @class */ (function () {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (maxAge) {
                if (maxAge === void 0) { maxAge = REGISTRY_FINALIZE_AFTER; }
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function (registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) {
                    _this.scheduleSweep();
                }
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.sweepTimeout === undefined) {
                this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL);
            }
        }
    });
    return TimerBasedFinalizationRegistry;
}());

var UniversalFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
    ? FinalizationRegistry
    : TimerBasedFinalizationRegistry;
//# sourceMappingURL=UniversalFinalizationRegistry.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/observerFinalizationRegistry.js

var observerFinalizationRegistry = new UniversalFinalizationRegistry(function (adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 ? void 0 : _a.dispose();
    adm.reaction = null;
});
//# sourceMappingURL=observerFinalizationRegistry.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-sync-external-store@1.2.2_react@0.0.0-experimental-4ead6b530/node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(82348);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useObserver.js






function createReaction(adm) {
    adm.reaction = new mobx_esm.Reaction("observer".concat(adm.name), function () {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 ? void 0 : _a.call(adm);
    });
}
function useObserver(render, baseComponentName) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (isUsingStaticRendering()) {
        return render();
    }
    var admRef = react.useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function (onStoreChange) {
                // Do NOT access admRef here!
                observerFinalizationRegistry.unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function () {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 ? void 0 : _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function () {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        observerFinalizationRegistry.register(admRef, adm, adm);
    }
    react.useDebugValue(adm.reaction, printDebugValue);
    (0,shim.useSyncExternalStore)(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function () {
        try {
            renderResult = render();
        }
        catch (e) {
            exception = e;
        }
    });
    if (exception) {
        throw exception; // re-throw any exceptions caught during rendering
    }
    return renderResult;
}
//# sourceMappingURL=useObserver.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/observer.js
var _a, _b;



var warnObserverOptionsDeprecated = true;
var hasSymbol = typeof Symbol === "function" && Symbol.for;
var isFunctionNameConfigurable = (_b = (_a = Object.getOwnPropertyDescriptor(function () { }, "name")) === null || _a === void 0 ? void 0 : _a.configurable) !== null && _b !== void 0 ? _b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var ReactForwardRefSymbol = hasSymbol
    ? Symbol.for("react.forward_ref")
    : typeof react.forwardRef === "function" && (0,react.forwardRef)(function (props) { return null; })["$$typeof"];
var ReactMemoSymbol = hasSymbol
    ? Symbol.for("react.memo")
    : typeof react.memo === "function" && (0,react.memo)(function (props) { return null; })["$$typeof"];
// n.b. base case is not used for actual typings or exported in the typing files
function observer(baseComponent, 
// TODO remove in next major
options) {
    var _a;
    if (false) {}
    if (ReactMemoSymbol && baseComponent["$$typeof"] === ReactMemoSymbol) {
        throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    }
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if (isUsingStaticRendering()) {
        return baseComponent;
    }
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if (ReactForwardRefSymbol && baseComponent["$$typeof"] === ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") {
            throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
        }
    }
    var observerComponent = function (props, ref) {
        return useObserver(function () { return render(props, ref); }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if (isFunctionNameConfigurable) {
        Object.defineProperty(observerComponent, "name", {
            value: baseComponent.name,
            writable: true,
            configurable: true
        });
    }
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) {
        ;
        observerComponent.contextTypes = baseComponent.contextTypes;
    }
    if (useForwardRef) {
        // `forwardRef` must be applied prior `memo`
        // `forwardRef(observer(cmp))` throws:
        // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
        observerComponent = (0,react.forwardRef)(observerComponent);
    }
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0,react.memo)(observerComponent);
    copyStaticProperties(baseComponent, observerComponent);
    if (false) {}
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function copyStaticProperties(base, target) {
    Object.keys(base).forEach(function (key) {
        if (!hoistBlackList[key]) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
        }
    });
}
//# sourceMappingURL=observer.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/ObserverComponent.js

function ObserverComponent(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") {
        return null;
    }
    return useObserver(component);
}
if (false) {}
ObserverComponent.displayName = "Observer";

function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) {
        return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    }
    if (hasProp || hasExtraProp) {
        return null;
    }
    return new Error("Invalid prop `" +
        propFullName +
        "` of type `" +
        typeof props[key] +
        "` supplied to" +
        " `" +
        componentName +
        "`, expected `function`.");
}
//# sourceMappingURL=ObserverComponent.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useLocalObservable.js


function useLocalObservable(initializer, annotations) {
    return (0,react.useState)(function () { return (0,mobx_esm.observable)(initializer(), annotations, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useAsObservableSource.js



function useAsObservableSource_useAsObservableSource(current) {
    if (false)
        {}
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = useState(function () { return observable(current, {}, { deep: false }); })[0];
    runInAction(function () {
        Object.assign(res, current);
    });
    return res;
}
//# sourceMappingURL=useAsObservableSource.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useLocalStore.js




function useLocalStore(initializer, current) {
    if (false) {}
    var source = current && useAsObservableSource(current);
    return useState(function () { return observable(initializer(source), undefined, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalStore.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js
var es_a;







observerBatching(react_dom.unstable_batchedUpdates);







var clearTimers = (es_a = observerFinalizationRegistry["finalizeAllImmediately"]) !== null && es_a !== void 0 ? es_a : (function () { });
function es_useObserver(fn, baseComponentName) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (false) {}
    return useObserverOriginal(fn, baseComponentName);
}

function useStaticRendering(enable) {
    if (false) {}
    enableStaticRendering(enable);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 31772:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(25148);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 7862:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(31772)();
}


/***/ }),

/***/ 25148:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 4534:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GlobalHotKeys: () => (/* binding */ GlobalHotKeys$1),
/* harmony export */   HotKeys: () => (/* binding */ HotKeys),
/* harmony export */   IgnoreKeys: () => (/* binding */ IgnoreKeys),
/* harmony export */   configure: () => (/* binding */ configure),
/* harmony export */   getApplicationKeyMap: () => (/* binding */ getApplicationKeyMap)
/* harmony export */ });
/* unused harmony exports ObserveKeys, withHotKeys, withIgnoreKeys, withObserveKeys, recordKeyCombination */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7862);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/**
 * ISC License
 *
 * Copyright (c) 2018, Aleck Greenham
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */




function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function arrayFrom(a){return Array.isArray(a)?a:a?[a]:[]}

function nop(a){return a}

function dictionaryFrom(a){var b=!(1<arguments.length&&arguments[1]!==void 0)||arguments[1],c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:nop,d=3<arguments.length&&arguments[3]!==void 0?arguments[3]:{},e=function(){return "function"==typeof b?b:function(){return b}}();return arrayFrom(a).reduce(function(a,b){return a[c(b)]=e(b),a},d)}

var objectValues = (function(a){return Object.keys(a).map(function(b){return a[b]})});

var _defaultConfiguration={logLevel:"warn",defaultKeyEvent:"keydown",defaultComponent:"div",defaultTabIndex:"-1",ignoreTags:["input","select","textarea"],ignoreKeymapAndHandlerChangesByDefault:!0,ignoreEventsCondition:function c(a){var b=a.target;if(b&&b.tagName){var d=b.tagName.toLowerCase();return Configuration.option("_ignoreTagsDict")[d]||b.isContentEditable}return !1},ignoreRepeatedEventsWhenKeyHeldDown:!0,simulateMissingKeyPressEvents:!0,stopEventPropagationAfterHandling:!0,stopEventPropagationAfterIgnoring:!0,allowCombinationSubmatches:!1,customKeyCodes:{}},_configuration=_objectSpread({},_defaultConfiguration);_configuration._ignoreTagsDict=dictionaryFrom(_configuration.ignoreTags);var Configuration=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"init",value:function e(a){var b=this,c=a.ignoreTags,d=a.customKeyCodes;c&&(a._ignoreTagsDict=dictionaryFrom(a.ignoreTags)),d&&(a._customKeyNamesDict=dictionaryFrom(objectValues(a.customKeyCodes))),-1!==["verbose","debug","info"].indexOf(a.logLevel)&&console.warn("React HotKeys: You have requested log level '".concat(a.logLevel,"' but for performance reasons, logging below severity level 'warning' is disabled in production. Please use the development build for complete logs.")),Object.keys(a).forEach(function(c){b.set(c,a[c]);});}},{key:"set",value:function c(a,b){_configuration[a]=b;}},{key:"reset",value:function b(a){_configuration[a]=_defaultConfiguration[a];}},{key:"option",value:function b(a){return _configuration[a]}}]),a}();

function backwardsCompatibleContext(a,b){var c=b.deprecatedAPI,d=c.contextTypes,e=c.childContextTypes,f=b.newAPI.contextType;if("undefined"==typeof react__WEBPACK_IMPORTED_MODULE_0__.createContext)a.contextTypes=d,a.childContextTypes=e,a.prototype.getChildContext=function(){return this._manager.childContext};else{var g=react__WEBPACK_IMPORTED_MODULE_0__.createContext(f);a.contextType=g,a.prototype._originalRender=a.prototype.render,a.prototype.render=function(){var a=this._originalRender();return a?react__WEBPACK_IMPORTED_MODULE_0__.createElement(g.Provider,{value:this._manager.childContext},a):null};}return a}

function isUndefined(a){return "undefined"==typeof a}

var Logger=function(){function a(){var b=this,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"warn";_classCallCheck(this,a),_defineProperty(this,"verbose",this.noop),_defineProperty(this,"debug",this.noop),_defineProperty(this,"info",this.noop),_defineProperty(this,"warn",this.noop),_defineProperty(this,"error",this.noop),this.logLevel=this.constructor.levels[c];for(var d,e=["error","warn","info","debug","verbose"],f=function(){var a=e[g];if(b.logLevel<b.constructor.levels[a])return {v:void 0};var c=-1===["debug","verbose"].indexOf(a)?console[a]:console.log;b[a]=function(){for(var a=arguments.length,b=Array(a),d=0;d<a;d++)b[d]=arguments[d];var e=b.map(function(a){return "function"==typeof a?a():a});c.apply(void 0,_toConsumableArray(e));};},g=0;g<e.length;g++)if(d=f(),"object"===_typeof(d))return d.v}return _createClass(a,[{key:"noop",value:function a(){}}]),a}();_defineProperty(Logger,"logIcons",["\uD83D\uDCD5","\uD83D\uDCD7","\uD83D\uDCD8","\uD83D\uDCD9"]),_defineProperty(Logger,"componentIcons",["\uD83D\uDD3A","\u2B50\uFE0F","\uD83D\uDD37","\uD83D\uDD36","\u2B1B\uFE0F"]),_defineProperty(Logger,"eventIcons",["\u2764\uFE0F","\uD83D\uDC9A","\uD83D\uDC99","\uD83D\uDC9B","\uD83D\uDC9C","\uD83E\uDDE1"]),_defineProperty(Logger,"levels",{none:0,error:1,warn:2,info:3,debug:4,verbose:5});

var KeyEventType={keydown:0,keypress:1,keyup:2};

var KeyEventSequenceIndex={previous:0,current:1};

var ShiftedKeysDictionary={"`":["~"],1:["!"],2:["@","\""],3:["#","\xA3"],4:["$"],5:["%"],6:["^"],7:["&"],8:["*"],9:["("],0:[")"],"-":["_"],"=":["plus"],";":[":"],"'":["\"","@"],",":["<"],".":[">"],"/":["?"],"\\":["|"],"[":["{"],"]":["}"],"#":["~"]};

function fallbackToTransformedSelf(a,b,c){return a[b]||[1===b.length?b[c]():b]}

function resolveShiftedAlias(a){return fallbackToTransformedSelf(ShiftedKeysDictionary,a,"toUpperCase")}

function hasKey(a,b){return a.hasOwnProperty(b)}

function invertArrayDictionary(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{};return Object.keys(a).reduce(function(c,d){var e=a[d];return e.forEach(function(a){hasKey(c,a)||(c[a]=[]),c[a].push(d);}),b.includeOriginal&&(!hasKey(c,d)&&(c[d]=[]),c[d]=[].concat(_toConsumableArray(c[d]),_toConsumableArray(e))),c},{})}

var UnshiftedKeysDictionary=invertArrayDictionary(ShiftedKeysDictionary);

function resolveUnshiftedAlias(a){return fallbackToTransformedSelf(UnshiftedKeysDictionary,a,"toLowerCase")}

var KeyOSAndLayoutAliasesDictionary={};var KeyOSAndLayoutAliasesDictionary$1 = invertArrayDictionary(KeyOSAndLayoutAliasesDictionary,{includeOriginal:!0});

function isString(a){return "string"==typeof a}

function stripSuperfluousWhitespace(a){return isString(a)?a.trim().replace(/\s+/g," "):a}

var MousetrapToReactKeyNamesDictionary={tab:"Tab",capslock:"CapsLock",shift:"Shift",meta:"Meta",alt:"Alt",ctrl:"Control",space:" ",spacebar:" ",escape:"Escape",esc:"Escape",left:"ArrowLeft",right:"ArrowRight",up:"ArrowUp",down:"ArrowDown",return:"Enter",del:"Delete",command:"Meta",option:"Alt",enter:"Enter",backspace:"Backspace",ins:"Insert",pageup:"PageUp",pagedown:"PageDown",end:"End",home:"Home",contextmenu:"ContextMenu",numlock:"Clear"};

var KeyShorthandDictionary={cmd:"Meta"};

var AltShiftedKeysDictionary={"`":["`"],1:["\u2044"],2:["\u20AC"],3:["\u2039"],4:["\u203A"],5:["\uFB01"],6:["\uFB02"],7:["\u2021"],8:["\xB0"],9:["\xB7"],0:["\u201A"],"-":["\u2014"],"=":["\xB1"],a:["\xC5"],b:["\u0131"],c:["\xC7"],d:["\xCE"],e:["\xB4"],f:["\xCF"],g:["\u02DD"],h:["\xD3"],i:["\u02C6"],j:["\xD4"],k:["\uF8FF"],l:["\xD2"],m:["\xC2"],n:["\u02DC"],o:["\xD8"],p:["\u03C0"],q:["\u0152"],r:["\u2030"],s:["\xCD"],t:["\xCE"],u:["\xA8"],v:["\u25CA"],w:["\u201E"],x:["\u02DB"],y:["\xC1"],z:["\xB8"],"[":["\u201D"],"]":["\u2019"],"\\":["\xBB"],"'":["\xC6"],";":["\xDA"],",":["\xAF"],".":["\u02D8"]};

var UnaltShiftedKeysDictionary=invertArrayDictionary(AltShiftedKeysDictionary);

function resolveUnaltShiftedAlias(a){return UnaltShiftedKeysDictionary[a]||resolveUnshiftedAlias(a)}

function standardizeKeyName(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{shift:!1,alt:!1},c=a.toLowerCase(),d=MousetrapToReactKeyNamesDictionary[c]||KeyShorthandDictionary[c]||(a.match(/^f\d+$/)?a.toUpperCase():a);return b.shift?b.alt?resolveUnaltShiftedAlias(d):resolveUnshiftedAlias(d):d}

var translateToKey={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};

var NonPrintableKeysDictionary=dictionaryFrom(objectValues(translateToKey));

function isNonPrintableKeyName(a){return !!NonPrintableKeysDictionary[a]}

function isCustomKeyName(a){return Configuration.option("_customKeyNamesDict")[a]}

function isValidKey(a){return isNonPrintableKeyName(a)||String.fromCharCode(a.charCodeAt(0))===a||isCustomKeyName(a)}var InvalidKeyNameError=function(a){function b(){var a,c;_classCallCheck(this,b);for(var d=arguments.length,e=Array(d),f=0;f<d;f++)e[f]=arguments[f];return c=_possibleConstructorReturn(this,(a=_getPrototypeOf(b)).call.apply(a,[this].concat(e))),_defineProperty(_assertThisInitialized(_assertThisInitialized(c)),"name","InvalidKeyNameError"),c}return _inherits(b,a),b}(_wrapNativeSuper(Error));

function normalizedCombinationId(a){return Object.keys(a).sort(function(c,a){return c.length===a.length?c<a?-1:c>a?1:0:a.length-c.length}).join("+")}

var KeySequenceParser=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"parse",value:function k(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=stripSuperfluousWhitespace(a),d=c.split(" ");try{var e=d.slice(0,d.length-1),f=d[d.length-1],g=e.map(function(a){var c=parseCombination(a,b);return normalizedCombinationId(c)}).join(" "),h=parseCombination(f,b),i=normalizedCombinationId(h),j={id:i,keyDictionary:h,keyEventType:b.keyEventType,size:Object.keys(h).length};return {sequence:{prefix:g,size:e.length+1},combination:j}}catch(a){return {sequence:null,combination:null}}}}]),a}();function parseCombination(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{},c=-1!==a.indexOf(/[sS]hift/),d=-1!==a.indexOf(/[aA]lt/);return a.replace(/^\+|(\s|[^+]\+)\+/,"$1plus").split("+").reduce(function(a,e){var f=standardizeKeyName(e,{shift:c,alt:d});if(b.ensureValidKeys&&!isValidKey(f))throw new InvalidKeyNameError;return a[f]=!0,a},{})}

var AltedKeysDictionary={"`":["`"],1:["\xA1"],2:["\u2122"],3:["\xA3"],4:["\xA2"],5:["\u221E"],6:["\xA7"],7:["\xB6"],8:["\u2022"],9:["\xAA"],0:["\xBA"],"-":["\u2013"],"=":["\u2260"],a:["\xE5"],b:["\u222B"],c:["\xE7"],d:["\u2202"],e:["\xB4"],f:["\u0192"],g:["\xA9"],h:["\u02D9"],i:["\u02C6"],j:["\u2206"],k:["\u02DA"],l:["\xAC"],m:["\xB5"],n:["\u02DC"],o:["\xF8"],p:["\u03C0"],q:["\u0153"],r:["\xAE"],s:["\xDF"],t:["\u2020"],u:["\xA8"],v:["\u221A"],w:["\u2211"],x:["\u2248"],y:["\xA5"],z:["\u03A9"],"[":["\u201C"],"]":["\u2018"],"\\":["\xAB"],"'":["\xE6"],";":["\u2026"],",":["\u2264"],".":["\u2265"],"/":["\xF7"]};

var UnaltedKeysDictionary=invertArrayDictionary(AltedKeysDictionary);

function resolveUnaltedAlias(a){return UnaltedKeysDictionary[a]||[a]}

function resolveAltedAlias(a){return AltedKeysDictionary[a]||[a]}

function resolveAltShiftedAlias(a){return AltShiftedKeysDictionary[a]||[a]}

function isObject(a){return !Array.isArray(a)&&"object"===_typeof(a)&&null!==a}

function size(a){return isObject(a)?Object.keys(a).length:a.length}

function distinct(a){return Object.keys(dictionaryFrom(a))}

function buildShiftedKeyAliases(a,b){return a?[].concat(_toConsumableArray(resolveAltShiftedAlias(b)),_toConsumableArray(resolveUnaltShiftedAlias(b)),[b]):[].concat(_toConsumableArray(resolveShiftedAlias(b)),_toConsumableArray(resolveUnshiftedAlias(b)),[b])}function buildAltKeyAliases(a){return [].concat(_toConsumableArray(resolveAltedAlias(a)),_toConsumableArray(resolveUnaltedAlias(a)),[a])}function buildOSAndKeyboardLayoutAliases(a){var b=KeyOSAndLayoutAliasesDictionary$1[a];return b?[a].concat(_toConsumableArray(b)):[a]}function buildKeyAliasList(a,b){var c=a.Shift,d=a.Alt,e=function(){return c?buildShiftedKeyAliases(d,b):d?buildAltKeyAliases(b):buildOSAndKeyboardLayoutAliases(b)}();return distinct(e)}function buildKeyCombinationPermutations(a){return Object.keys(a).reduce(function(b,c){var d=buildKeyAliasList(a,c);return 0===size(b)?d.map(function(a){return _defineProperty({},a,!0)}):d.reduce(function(a,c){return a.concat(b.map(function(a){return _objectSpread({},a,_defineProperty({},c,!0))}))},[])},[])}var KeyCombinationSerializer=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"serialize",value:function c(a){var b=buildKeyCombinationPermutations(a);return b.map(normalizedCombinationId)}},{key:"isValidKeySerialization",value:function b(a){return !!(0<a.length)&&!!KeySequenceParser.parse(a,{ensureValidKeys:!0}).combination}}]),a}();

function resolveKeyAlias(a){return KeyOSAndLayoutAliasesDictionary$1[a]||[a]}

function applicableAliasFunctions(a){return a.Shift?a.Alt?[resolveAltShiftedAlias,resolveUnaltShiftedAlias]:[resolveShiftedAlias,resolveUnshiftedAlias]:a.Alt?[resolveAltedAlias,resolveUnaltedAlias]:[nop$1,nop$1]}function nop$1(a){return [a]}

var KeyEventState={unseen:0,seen:1,simulated:2};

var KeyEventStateArrayManager=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"newRecord",value:function d(a,b){var c=[KeyEventState.unseen,KeyEventState.unseen,KeyEventState.unseen];if(!isUndefined(a))for(var e=0;e<=a;e++)c[e]=b;return c}},{key:"setBit",value:function d(a,b,c){return a[b]=c,a}},{key:"clone",value:function d(a){for(var b=this.newRecord(),c=0;c<a.length;c++)b[c]=a[c];return b}}]),a}();

function isEmpty(a){return isObject(a)?0===Object.keys(a).length:!a||0===a.length}

function lazyLoadAttribute(a,b,c){return a[b]||(a[b]="function"==typeof c?c():c),a[b]}

var ModifierFlagsDictionary={Shift:["shiftKey"],Meta:["metaKey"],Control:["ctrlKey"],Alt:["altKey"]};

function stateFromEvent(a){return a.simulated?KeyEventState.simulated:KeyEventState.seen}

var KeyCombination=function(){function a(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,a),this.keyStates=b,this.isEnding=!1,this._keyAliases=void 0,this._ids=void 0;}return _createClass(a,[{key:"getNormalizedKeyName",value:function d(a){var b=this.keyStates[a];if(b)return a;var c=this.keyAliases[a];return c?c:a}},{key:"hasEnded",value:function a(){return isEmpty(this.keysStillPressedDict())}},{key:"addKey",value:function c(a,b){this._setKeyState(a,[KeyEventStateArrayManager.newRecord(),KeyEventStateArrayManager.newRecord(KeyEventType.keydown,b)]);}},{key:"setKeyState",value:function g(a,b,c){var d=this._getKeyState(a);if(this.isKeyIncluded(a)){var e=KeyEventStateArrayManager.clone(d[1]),f=KeyEventStateArrayManager.clone(e);KeyEventStateArrayManager.setBit(f,b,c),this._setKeyState(a,[e,f]);}else this.addKey(a,c);b===KeyEventType.keyup&&(this.isEnding=!0);}},{key:"keysStillPressedDict",value:function b(){var a=this;return this.keys.reduce(function(b,c){return a.isKeyStillPressed(c)&&(b[c]=a._getKeyState(c)),b},{})}},{key:"isKeyIncluded",value:function b(a){return !!this._getKeyState(a)}},{key:"isKeyStillPressed",value:function b(a){return this.isEventTriggered(a,KeyEventType.keypress)&&!this.isKeyReleased(a)}},{key:"isKeyReleased",value:function b(a){return this.isEventTriggered(a,KeyEventType.keyup)}},{key:"isEventTriggered",value:function c(a,b){return this._getKeyStateType(a,KeyEventSequenceIndex.current,b)}},{key:"wasEventPreviouslyTriggered",value:function c(a,b){return this._getKeyStateType(a,KeyEventSequenceIndex.previous,b)}},{key:"isKeyPressSimulated",value:function b(a){return this.isEventTriggered(a,KeyEventType.keypress)===KeyEventState.simulated}},{key:"isKeyUpSimulated",value:function b(a){return this.isEventTriggered(a,KeyEventType.keyup)===KeyEventState.simulated}},{key:"resolveModifierFlagDiscrepancies",value:function e(a,b,c){var d=this;Object.keys(ModifierFlagsDictionary).forEach(function(e){if(b!==e||c!==KeyEventType.keyup){var f=d.isKeyStillPressed(e);ModifierFlagsDictionary[e].forEach(function(b){!1===a[b]&&f&&d.setKeyState(e,KeyEventType.keyup,stateFromEvent(a)),!0!==a[b]||f||d.setKeyState(e,KeyEventType.keydown,stateFromEvent(a));});}});}},{key:"_getKeyStateType",value:function e(a,b,c){var d=this._getKeyState(a);return d&&d[b][c]}},{key:"_getKeyState",value:function d(a){var b=this.keyStates[a];if(b)return b;var c=this.keyAliases[a];if(c)return this.keyStates[c]}},{key:"_setKeyState",value:function d(a,b){var c=this.getNormalizedKeyName(a);this.keyStates[c]=b,delete this._keyAliases,delete this._ids;}},{key:"ids",get:function b(){var a=this;return lazyLoadAttribute(this,"_ids",function(){return KeyCombinationSerializer.serialize(a.keyStates)})}},{key:"keyAliases",get:function b(){var a=this;return lazyLoadAttribute(this,"_keyAliases",function(){return buildKeyAliases(a.keyStates)})}},{key:"keys",get:function a(){return Object.keys(this.keyStates)}}]),a}();function buildKeyAliases(a){return Object.keys(a).reduce(function(b,c){return resolveKeyAlias(c).forEach(function(d){applicableAliasFunctions(a).forEach(function(a){a(d).forEach(function(a){(a!==c||c!==d)&&(b[a]=c);});});}),b},{})}

var KeyCombinationDecorator=function(){function a(b){_classCallCheck(this,a),this._keyCombination=b;}return _createClass(a,[{key:"describe",value:function a(){return this._keyCombination.ids[0]}},{key:"asKeyDictionary",value:function a(){return dictionaryFrom(this._keyCombination.keys)}},{key:"toJSON",value:function a(){return {keys:this._keyCombination.keyStates,ids:this._keyCombination.ids,keyAliases:this._keyCombination.keyAliases}}}]),a}();

var KeyCombinationIterator=function(){function a(b){_classCallCheck(this,a),this._keyCombination=b;}return _createClass(a,[{key:"any",value:function a(){return 0<this._getKeys().length}},{key:"forEachKey",value:function b(a){return this._getKeys().forEach(a)}},{key:"some",value:function b(a){return this._getKeys().some(a)}},{key:"_getKeys",value:function a(){return this._keyCombination.keys}},{key:"numberOfKeys",get:function a(){return size(this._getKeys())}}]),a}();

var KeyHistory=function(){function a(b){var c=b.maxLength,d=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null;_classCallCheck(this,a),this._combinations=[],this._maxLength=c,d?this._push(d):this._push(new KeyCombination);}return _createClass(a,[{key:"getPreviousCombinations",value:function b(a){return this._combinations.slice(-(a+1),-1)}},{key:"any",value:function a(){return this._combinations.some(function(a){return new KeyCombinationIterator(a).any()})}},{key:"addKeyToCurrentCombination",value:function d(a,b,c){this._ensureInitialKeyCombination(),this.currentCombination.setKeyState(a,b,c);}},{key:"startNewKeyCombination",value:function d(a,b){this._ensureInitialKeyCombination();var c=new KeyCombination(this.currentCombination.keysStillPressedDict());c.addKey(a,b),this._push(c);}},{key:"toJSON",value:function a(){return this._combinations.map(function(a){return new KeyCombinationDecorator(a).toJSON()})}},{key:"_ensureInitialKeyCombination",value:function a(){0===this.length&&this._push(new KeyCombination);}},{key:"_push",value:function b(a){this._trimHistory(),this._combinations.push(a);}},{key:"_trimHistory",value:function a(){for(;this.length>this._maxLength;)this._shift();}},{key:"_shift",value:function a(){this._combinations.shift();}},{key:"length",get:function a(){return this._combinations.length}},{key:"currentCombination",get:function a(){return this._combinations[this.length-1]}},{key:"maxLength",set:function b(a){this._maxLength=a,this._trimHistory();}}]),a}();

var Registry=function(){function a(){_classCallCheck(this,a),this._registry={};}return _createClass(a,[{key:"get",value:function b(a){return this._registry[a]}},{key:"set",value:function c(a,b){this._registry[a]=b;}},{key:"remove",value:function b(a){delete this._registry[a];}},{key:"toJSON",value:function a(){return this._registry}}]),a}();

function without(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:[],c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{},d=dictionaryFrom(arrayFrom(b),function(a){return {value:a}});return Array.isArray(a)?a.reduce(function(a,b){return d[b]&&(c.stringifyFirst||d[b].value===b)||a.push(b),a},[]):isObject(a)?Object.keys(a).reduce(function(b,c){return d[c]||(b[c]=a[c]),b},{}):a}

var ComponentTree=function(a){function b(){var a;return _classCallCheck(this,b),a=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this)),a.clearRootId(),a}return _inherits(b,a),_createClass(b,[{key:"hasRoot",value:function a(){return !this.isRootId(null)}},{key:"isRootId",value:function b(a){return a===this.rootId}},{key:"clearRootId",value:function a(){this.rootId=null;}},{key:"add",value:function d(a,c){_get(_getPrototypeOf(b.prototype),"set",this).call(this,a,{childIds:[],parentId:null,keyMap:c});}},{key:"update",value:function e(a,c){var d=_get(_getPrototypeOf(b.prototype),"get",this).call(this,a);_get(_getPrototypeOf(b.prototype),"set",this).call(this,a,_objectSpread({},d,{keyMap:c}));}},{key:"setParent",value:function c(a,b){isUndefined(b)?this.rootId=a:(this.get(a).parentId=b,this._addChildId(b,a));}},{key:"remove",value:function d(a){var c=this._getParentId(a);this._removeChildId(c,a),_get(_getPrototypeOf(b.prototype),"remove",this).call(this,a);}},{key:"_getParentId",value:function c(a){var b=this.get(a);return b&&b.parentId}},{key:"_addChildId",value:function c(a,b){this.get(a).childIds.push(b);}},{key:"_removeChildId",value:function d(a,b){var c=this.get(a);c&&(c.childIds=without(c.childIds,b));}}]),b}(Registry);

function removeAtIndex(a,b){return [].concat(_toConsumableArray(a.slice(0,b)),_toConsumableArray(a.slice(b+1)))}

var ComponentOptionsListIterator=function(){function a(b){_classCallCheck(this,a),this._list=b,this.position=-1;}return _createClass(a,[{key:"getComponent",value:function a(){return this._list.getAtPosition(this.position)}},{key:"next",value:function a(){return this.position+1<this._list.length?(this.position++,this.getComponent()):null}}]),a}();

var ComponentOptionsList=function(){function a(){_classCallCheck(this,a),this._list=[],this._idToIndex={},this.longestSequence=1,this._longestSequenceComponentId=null,this._keyMapEventRecord=KeyEventStateArrayManager.newRecord();}return _createClass(a,[{key:"add",value:function g(a,b,c,d){if(this.containsId(a))return this.update(a,b,c,d);var e=this._build(a,b,c,d);this._list.push(e);var f=this.length-1;return this._idToIndex[a]=f}},{key:"containsId",value:function b(a){return !!this.getById(a)}},{key:"getById",value:function b(a){return this.getAtPosition(this.getPositionById(a))}},{key:"getPositionById",value:function b(a){return this._idToIndex[a]}},{key:"update",value:function h(a,b,c,d){var e=this._isUpdatingComponentWithLongestSequence(a),f=this.longestSequence,g=this._build(a,b,c,d);e&&g.sequenceLength!==f&&(g.sequenceLength>f?this.longestSequence=g.sequenceLength:this._recalculateLongestSequence()),this._list[this.getPositionById(a)]=g;}},{key:"remove",value:function c(a){var b=this._isUpdatingComponentWithLongestSequence(a);this.removeAtPosition(this.getPositionById(a)),b&&this._recalculateLongestSequence();}},{key:"isRoot",value:function b(a){return this.getPositionById(a)>=this.length-1}},{key:"anyActionsForEventType",value:function b(a){return !!this._keyMapEventRecord[a]}},{key:"getAtPosition",value:function b(a){return this._list[a]}},{key:"removeAtPosition",value:function b(a){this._list=removeAtIndex(this._list,a);for(var c=a;c<this.length;)this._idToIndex[this.getAtPosition(c).componentId]=c,c++;}},{key:"toJSON",value:function a(){return this._list}},{key:"_build",value:function f(a,b,c,d){var e=this._buildActionDictionary(b,d,a);return {actions:e,handlers:c,componentId:a,options:d}}},{key:"_isUpdatingComponentWithLongestSequence",value:function b(a){return a===this._getLongestSequenceComponentId()}},{key:"_getLongestSequenceComponentId",value:function a(){return this._longestSequenceComponentId}},{key:"_recalculateLongestSequence",value:function d(){for(var e=this.iterator;e.next();){var a=e.getComponent(),b=a.longestSequence,c=a.componentId;b>this.longestSequence&&(this._longestSequenceComponentId=c,this.longestSequence=b);}}},{key:"_buildActionDictionary",value:function e(a,b,c){var d=this;return Object.keys(a).reduce(function(e,f){var g=a[f],h=function(){return isObject(g)&&hasKey(g,"sequences")?arrayFrom(g.sequences):arrayFrom(g)}();return h.forEach(function(a){var g=normalizeActionOptions(a,b),h=g.keySequence,i=g.keyEventType;d._addActionOptions(e,c,f,h,i);}),e},{})}},{key:"_addActionOptions",value:function i(a,b,c,d,e){var f=KeySequenceParser.parse(d,{keyEventType:e}),g=f.sequence,h=f.combination;g.size>this.longestSequence&&(this.longestSequence=g.size,this._longestSequenceComponentId=b),this._keyMapEventRecord[e]=KeyEventState.seen,a[c]||(a[c]=[]),a[c].push(_objectSpread({prefix:g.prefix,actionName:c,sequenceLength:g.size},h));}},{key:"iterator",get:function a(){return new ComponentOptionsListIterator(this)}},{key:"length",get:function a(){return this._list.length}}]),a}();function normalizeActionOptions(a,b){if(isObject(a)){var c=a.sequence,d=a.action;return {keySequence:c,keyEventType:isUndefined(d)?KeyEventType[b.defaultKeyEvent]:KeyEventType[d]}}return {keySequence:a,keyEventType:KeyEventType[b.defaultKeyEvent]}}

function indexFromEnd(a,b){return a[a.length-(b+1)]}

for(var KeysWithKeyUpHiddenByCmd={Enter:!0,Backspace:!0,ArrowRight:!0,ArrowLeft:!0,ArrowUp:!0,ArrowDown:!0,CapsLock:!0},i=1;13>i;i++)KeysWithKeyUpHiddenByCmd["F".concat(i)]=!0;

function keyupIsHiddenByCmd(a){return 1===a.length||hasKey(KeysWithKeyUpHiddenByCmd,a)}

var KeyCombinationMatcher=function(){function a(){_classCallCheck(this,a),this._actionConfigs={},this._order=null;}return _createClass(a,[{key:"addMatch",value:function f(a,b){if(this._includesMatcherForCombination(a.id)){var c=a.keyEventType,d=a.actionName,e=a.id;this._addHandlerToActionConfig(e,{keyEventType:c,actionName:d,handler:b});}else this._addNewActionConfig(a,b);}},{key:"findMatch",value:function l(a,b,c){var d=this;lazyLoadAttribute(this,"order",function(){return d._setOrder()});var e=!0,f=!1,g=void 0;try{for(var h,i=this._order[Symbol.iterator]();!(e=(h=i.next()).done);e=!0){var j=h.value,k=this._actionConfigs[j];if(this._matchesActionConfig(a,b,c,k))return k}}catch(a){f=!0,g=a;}finally{try{e||null==i.return||i.return();}finally{if(f)throw g}}return null}},{key:"toJSON",value:function a(){return {actionConfigs:this._actionConfigs,order:this._order}}},{key:"_matchesActionConfig",value:function h(a,b,c,d){if(!canBeMatched(a,d)||!d.events[c])return !1;var e=!1,f=Object.keys(d.keyDictionary),g=f.every(function(d){return !!a.isEventTriggered(d,c)&&(b&&b===a.getNormalizedKeyName(d)&&(e=!a.wasEventPreviouslyTriggered(d,c)),!0)});return g&&e}},{key:"_setOrder",value:function b(){var a=objectValues(this._actionConfigs).reduce(function(a,b){var c=b.id,d=b.size;return a[d]||(a[d]=[]),a[d].push(c),a},{});this._order=Object.keys(a).sort(function(c,a){return a-c}).reduce(function(b,c){return b.concat(a[c])},[]);}},{key:"_addNewActionConfig",value:function j(a,b){var c=a.prefix,d=a.sequenceLength,e=a.id,f=a.keyDictionary,g=a.size,h=a.keyEventType,i=a.actionName;this._setCombinationMatcher(e,{prefix:c,sequenceLength:d,id:e,keyDictionary:f,size:g,events:{}}),this._addHandlerToActionConfig(e,{keyEventType:h,actionName:i,handler:b});}},{key:"_addHandlerToActionConfig",value:function g(a,b){var c=b.keyEventType,d=b.actionName,e=b.handler,f=this._getCombinationMatcher(a);this._setCombinationMatcher(a,_objectSpread({},f,{events:_objectSpread({},f.events,_defineProperty({},c,{actionName:d,handler:e}))}));}},{key:"_setCombinationMatcher",value:function c(a,b){this._actionConfigs[a]=b;}},{key:"_getCombinationMatcher",value:function b(a){return this._actionConfigs[a]}},{key:"_includesMatcherForCombination",value:function b(a){return !!this._getCombinationMatcher(a)}}]),a}();function canBeMatched(a,b){var c=size(b.keyDictionary),d=new KeyCombinationIterator(a),e=b.keyDictionary.Meta&&keyUpIsBeingHidden(a);return Configuration.option("allowCombinationSubmatches")||e?d.numberOfKeys>=c:d.numberOfKeys===c}function keyUpIsBeingHidden(a){return !!a.isKeyStillPressed("Meta")&&new KeyCombinationIterator(a).some(function(a){return keyupIsHiddenByCmd(a)})}

function updateIndexCounters(a,b){for(var c=0,d=!0;d&&c<a.length;){var e=indexFromEnd(a,c),f=(e+1)%(indexFromEnd(b,c)||1);a[a.length-(c+1)]=f,d=0==f,d&&c++;}return c===a.length}var KeyHistoryMatcher=function(){function a(){_classCallCheck(this,a),this._combinationMatchers={},this._eventRecord=KeyEventStateArrayManager.newRecord();}return _createClass(a,[{key:"addMatch",value:function d(a,b){var c=this._getOrCreateCombinationMatcher(a.prefix);c.addMatch(a,b),KeyEventStateArrayManager.setBit(this._eventRecord,a.keyEventType,KeyEventState.seen),(!this.longestSequence||this.longestSequence<a.sequenceLength)&&(this.longestSequence=a.sequenceLength);}},{key:"findMatch",value:function e(a,b,c){var d=this._findCombinationMatcher(a);return d?d.findMatch(a.currentCombination,a.currentCombination.getNormalizedKeyName(b),c):null}},{key:"hasMatchesForEventType",value:function b(a){return !!this._eventRecord[a]}},{key:"toJSON",value:function b(){var a=this;return Object.keys(this._combinationMatchers).reduce(function(b,c){var d=a._combinationMatchers[c];return b[c]=d.toJSON(),b},{})}},{key:"_getOrCreateCombinationMatcher",value:function b(a){return lazyLoadAttribute(this._combinationMatchers,a,function(){return new KeyCombinationMatcher})}},{key:"_findCombinationMatcher",value:function h(a){var b=a.getPreviousCombinations(this.longestSequence-1);if(0===b.length)return this._combinationMatchers[""];var c=b.map(function(a){return a.ids}),d=c.map(function(a){return a.length}),e=Array(c.length).fill(0);do{var f=e.map(function(a,b){return c[b][a]}),g=f.join(" ");if(this._combinationMatchers[g])return this._combinationMatchers[g]}while(!updateIndexCounters(e,d));return this._combinationMatchers[""]}}]),a}();

function printComponent(a){return JSON.stringify(a,componentAttributeSerializer,4)}function componentAttributeSerializer(a,b){return "function"==typeof b?b.toString():b}

function describeKeyEventType(a){switch(parseInt(a,10)){case 0:return "keydown";case 1:return "keypress";default:return "keyup";}}

var ActionResolver=function(){function a(b,c,d){_classCallCheck(this,a),this.logger=d,this._eventStrategy=c,this._keyMapMatchers=[],this._unmatchedHandlerStatus=[],this._handlersDictionary={},this._keySequencesDictionary={};for(var g=b.iterator;g.next();){var e=g.getComponent(),f=e.handlers;this._unmatchedHandlerStatus.push([Object.keys(f).length,{}]),this._keyMapMatchers.push(new KeyHistoryMatcher);}this._componentList=b,this._componentListIterator=b.iterator;}return _createClass(a,[{key:"getKeyHistoryMatcher",value:function b(a){if(this._componentHasUnmatchedHandlers(a))for(;this._componentListIterator.next();)this._addHandlersFromComponent(),this._addActionsFromComponent();return this._getKeyHistoryMatcher(a)}},{key:"componentHasActionsBoundToEventType",value:function c(a,b){return this.getKeyHistoryMatcher(a).hasMatchesForEventType(b)}},{key:"findMatchingKeySequenceInComponent",value:function e(a,b,c,d){return this.componentHasActionsBoundToEventType(a,d)?this.getKeyHistoryMatcher(a).findMatch(b,c,d):null}},{key:"callClosestMatchingHandler",value:function i(a,b,c,d,e){for(var f,g=this,h=function(){var d=g.getKeyHistoryMatcher(e),f=g._eventStrategy.componentList.getAtPosition(e),h=f.componentId;var i=g._eventStrategy.keyHistory,j=i.currentCombination,k=g.findMatchingKeySequenceInComponent(e,i,b,c);return k?(g._handleMatchFound(j,k,c,h,a,e),{v:!0}):void(g._handleMatchNotFound(j,e,c,h),e++)};e<=d;)if(f=h(),"object"===_typeof(f))return f.v}},{key:"_handleMatchNotFound",value:function f(a,b,c,d){var e=new KeyCombinationDecorator(a);if(this.componentHasActionsBoundToEventType(b,c));}},{key:"_handleMatchFound",value:function i(a,b,c,d,e,f){var g=new KeyCombinationDecorator(a),h=b.events[c];if(Configuration.option("allowCombinationSubmatches")){var j=KeyCombinationSerializer.serialize(b.keyDictionary);}h.handler(e),Configuration.option("stopEventPropagationAfterHandling")&&this._eventStrategy.stopEventPropagation(e,f);}},{key:"_getKeyHistoryMatcher",value:function b(a){return this._keyMapMatchers[a]}},{key:"_addActionsFromComponent",value:function d(){var a=this,b=this._componentListIterator.getComponent(),c=b.actions;Object.keys(c).forEach(function(b){a._buildActionMatchers(b,c[b]);});}},{key:"_buildActionMatchers",value:function e(a,b){var c=this,d=this._positionsOfComponentsWithHandlersFor(a);return !!d&&(this._registerActionWithMatcher(d,a,b),d.forEach(function(b){var d=c._getUnmatchedHandlerStatus(b),e=d[1];e[a]||(e[a]=!0,d[0]--);}),!0)}},{key:"_positionsOfComponentsWithHandlersFor",value:function b(a){return this._handlersDictionary[a]}},{key:"_registerActionWithMatcher",value:function h(a,b,c){var d=this,e=a[0],f=this._componentList.getAtPosition(e).handlers[b],g=this._getKeyHistoryMatcher(e);return c.forEach(function(a){var b=a.prefix,c=a.id,h=a.keyEventType,i=[b,c].join(" ");return !d._isClosestHandlerAlreadyFoundFor(i,h)&&void(g.addMatch(a,f),d._recordHandlerFoundFor(i,[e,h]))}),!0}},{key:"_addHandlersFromComponent",value:function d(){var a=this,b=this._componentListIterator.getComponent(),c=b.handlers;Object.keys(c).forEach(function(b){a._addHandler(b);});}},{key:"_addHandler",value:function b(a){lazyLoadAttribute(this._handlersDictionary,a,[]),this._handlersDictionary[a].push(this._componentListIterator.position);}},{key:"_recordHandlerFoundFor",value:function c(a,b){lazyLoadAttribute(this._keySequencesDictionary,a,[]),this._keySequencesDictionary[a].push(b);}},{key:"_componentHasUnmatchedHandlers",value:function b(a){return 0<this._getUnmatchedHandlerStatus(a)[0]}},{key:"_getUnmatchedHandlerStatus",value:function b(a){return this._unmatchedHandlerStatus[a]}},{key:"_isClosestHandlerAlreadyFoundFor",value:function d(a,b){var c=this._keySequencesDictionary[a]||[];return c.some(function(a){return a[1]===b})}}]),a}();

var AbstractKeyEventStrategy=function(){function a(){var c=1<arguments.length?arguments[1]:void 0;_classCallCheck(this,a),this.logger=null,this.componentId=-1,this.keyEventManager=c,this.componentTree=new ComponentTree,this._simulator=null,this._reset(),this.resetKeyHistory();}return _createClass(a,[{key:"_reset",value:function a(){this.componentList=new ComponentOptionsList,this._actionResolver=null;}},{key:"_recalculate",value:function a(){this._actionResolver=null,this.keyHistory.maxLength=this.componentList.longestSequence;}},{key:"resetKeyHistory",value:function b(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._simulator&&this._simulator.clear(),this._keyHistory=this.keyHistory.any()&&!a.force?new KeyHistory({maxLength:this.componentList.longestSequence},new KeyCombination(this)):this._newKeyHistory();}},{key:"_newKeyHistory",value:function a(){return new KeyHistory({maxLength:this.componentList.longestSequence})}},{key:"registerKeyMap",value:function c(a){return this.componentId+=1,this.componentTree.add(this.componentId,a),this.componentId}},{key:"reregisterKeyMap",value:function c(a,b){this.componentTree.update(a,b);}},{key:"registerComponentMount",value:function d(a,b){this.componentTree.setParent(a,b),void 0;}},{key:"deregisterKeyMap",value:function c(a){this.componentTree.remove(a),this.componentTree.isRootId(a)&&this.componentTree.clearRootId();}},{key:"_addComponent",value:function f(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},e=4<arguments.length?arguments[4]:void 0;this.componentList.add(a,b,c,e),this._recalculate(),this.logger.logComponentOptions(a,this.componentList.getById(a));}},{key:"_updateComponent",value:function e(a,b,c,d){this.componentList.update(a,b,c,d),this._recalculate(),this.logger.logComponentOptions(a,this.componentList.getById(a));}},{key:"_describeCurrentCombination",value:function b(){var a=new KeyCombinationDecorator(this.currentCombination);return a.describe()}},{key:"_recordKeyDown",value:function f(a,b,c){var d=stateFromEvent(a),e=this.currentCombination;e.isKeyIncluded(b)||e.isEnding?this._startAndLogNewKeyCombination(c,b,d):this._recordNewKeyInCombination(b,KeyEventType.keydown,d,c);}},{key:"_startAndLogNewKeyCombination",value:function d(a,b,c){this.keyHistory.startNewKeyCombination(b,c),this.logger.logKeyHistory(this.keyHistory,a);}},{key:"_recordNewKeyInCombination",value:function e(a,b,c,d){this.keyHistory.addKeyToCurrentCombination(a,b,c),this.logger.logKeyHistory(this.keyHistory,d);}},{key:"_isIgnoringRepeatedEvent",value:function e(a,b,c,d){return !!(a.repeat&&Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown"))&&(this.logger.logIgnoredKeyEvent(a,b,c,"it was a repeated event",d),!0)}},{key:"keyHistory",get:function b(){var a=this;return lazyLoadAttribute(this,"_keyHistory",function(){return a._newKeyHistory()})}},{key:"actionResolver",get:function b(){var a=this;return lazyLoadAttribute(this,"_actionResolver",function(){return new ActionResolver(a.componentList,a,a.logger)})}},{key:"currentCombination",get:function a(){return this.keyHistory.currentCombination}}]),a}();

function getEventCharCode(a){var b,c=a.keyCode;return "charCode"in a?(b=a.charCode,0===b&&13===c&&(b=13)):b=c,10===b&&(b=13),32<=b||13===b?b:0}

var normalizeKey={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"};function reactsGetEventKey(a){if(a.key){var b=normalizeKey[a.key]||a.key;if("Unidentified"!==b)return b}if("keypress"===a.type){var c=getEventCharCode(a);return 13===c?"Enter":String.fromCharCode(c)}return "keydown"===a.type||"keyup"===a.type?translateToKey[a.keyCode]||"Unidentified":""}

function keyNameFromEvent(a){var b=Configuration.option("customKeyCodes"),c=a.keyCode||a.charCode;return hasKey(b,c)?b[c]:a.nativeEvent?a.key:reactsGetEventKey(a)}function getKeyName(a){var b=keyNameFromEvent(a);return "+"===b?"plus":b}

function isCmdKey(a){return "Meta"===a}

function describeKeyEvent(a,b,c){var d="'".concat(b,"' ").concat(describeKeyEventType(c));return a.simulated?"(simulated) ".concat(d):d}

var EventResponse={unseen:0,ignored:1,seen:2,recorded:3,handled:4};

var KeyEventCounter=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"incrementId",value:function a(){this._id=this.id+1;}},{key:"id",get:function a(){return lazyLoadAttribute(this,"_id",0),this._id}}]),a}();

var EventPropagator=function(){function a(b){_classCallCheck(this,a),this._componentList=b,this._previousPropagation=null,this._reset();}return _createClass(a,[{key:"_reset",value:function a(){this.previousPosition=-1,this._position=-1,this._actionHandled=!1,this._ignoreEvent=!1,this._observeIgnoredEvents=!1,this._stopping=!1,this._componentId=null,this._key=null,this._type=null;}},{key:"isFirstPropagationStep",value:function b(){var a=this.previousPosition;return -1===a||a>=this._position}},{key:"isForKey",value:function b(a){return this._key===a}},{key:"isForEventType",value:function b(a){return this._type===a}},{key:"startNewPropagationStep",value:function e(a,b,c,d){return this._position=this._componentList.getPositionById(a),this._componentId=a,this.isFirstPropagationStep()&&(KeyEventCounter.incrementId(),this._key=b.key,this._type=d),!(b.repeat&&Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown"))||(this.ignoreEvent(b),!1)}},{key:"finishPropagationStep",value:function a(){this.isStopped()||this._componentList.isRoot(this._componentId)?(this._previousPropagation=this._clone(),this._reset()):this.previousPosition=this._position;}},{key:"observeIgnoredEvents",value:function a(){this._observeIgnoredEvents=!0;}},{key:"ignoreEvent",value:function b(a){return this._ignoreEvent=!0,!!(this.isIgnoringEvent()&&Configuration.option("stopEventPropagationAfterIgnoring"))&&(this.stop(a),this.finishPropagationStep(),!0)}},{key:"isIgnoringEvent",value:function a(){return !this._observeIgnoredEvents&&this._ignoreEvent}},{key:"isStopped",value:function a(){return this._stopping}},{key:"stop",value:function b(a){return !this.isStopped()&&(this._stopping=!0,a.simulated||a.stopPropagation(),!0)}},{key:"isPendingPropagation",value:function b(){var a=this.previousPosition;return -1!==a&&a+1<this._position}},{key:"isHandled",value:function a(){return this._actionHandled}},{key:"setHandled",value:function a(){this._actionHandled=!0;}},{key:"_clone",value:function e(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},c=b.copyState,d=new a(this._componentList);return d.logger=this.logger,(void 0===c||c)&&Object.assign(d,this),d}},{key:"previousPropagation",get:function b(){var a=this;return lazyLoadAttribute(this,"_previousPropagation",function(){return a._clone({copyState:!1})})}}]),a}();

function hasKeyPressEvent(a){return !isNonPrintableKeyName(a)}

var AbstractKeyEventSimulator=function(){function a(b){_classCallCheck(this,a),this._keyEventStrategy=b,this.clear();}return _createClass(a,[{key:"clear",value:function a(){this.keypressEventsToSimulate=[],this.keyupEventsToSimulate=[];}},{key:"cloneAndMergeEvent",value:function d(a,b){var c=Object.keys(ModifierFlagsDictionary).reduce(function(b,c){return b[c]=a[c],b},{});return _objectSpread({},c,b)}},{key:"_shouldSimulate",value:function e(a,b){var c=hasKeyPressEvent(b),d=this._keyEventStrategy.currentCombination;return a===KeyEventType.keypress?!c||c&&d.isKeyStillPressed("Meta"):a===KeyEventType.keyup&&keyupIsHiddenByCmd(b)&&d.isKeyReleased("Meta")}}]),a}();

var FocusOnlyKeyEventSimulator=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"handleKeyPressSimulation",value:function b(a){this._handleEventSimulation("keypressEventsToSimulate","simulatePendingKeyPressEvents",_objectSpread({eventType:KeyEventType.keypress},a));}},{key:"handleKeyUpSimulation",value:function b(a){this._handleEventSimulation("keyupEventsToSimulate","simulatePendingKeyUpEvents",_objectSpread({eventType:KeyEventType.keyup},a));}},{key:"_handleEventSimulation",value:function j(a,b,c){var d=c.event,e=c.eventType,f=c.key,g=c.focusTreeId,h=c.componentId,i=c.options;if(this._shouldSimulate(e,f)&&Configuration.option("simulateMissingKeyPressEvents")){var k=this.cloneAndMergeEvent(d,{key:f,simulated:!0});this[a].push({event:k,focusTreeId:g,componentId:h,options:i});}(this._keyEventStrategy.componentList.isRoot(h)||this._keyEventStrategy.eventPropagator.isStopped())&&this._shouldSimulateEventsImmediately()&&this._keyEventStrategy[b]();}},{key:"simulatePendingKeyPressEvents",value:function a(){this._simulatePendingKeyEvents("keypressEventsToSimulate","handleKeyPress");}},{key:"simulatePendingKeyUpEvents",value:function a(){this._simulatePendingKeyEvents("keyupEventsToSimulate","handleKeyUp");}},{key:"_simulatePendingKeyEvents",value:function d(a,b){var c=this;0<this[a].length&&KeyEventCounter.incrementId(),this[a].forEach(function(a){var d=a.event,e=a.focusTreeId,f=a.componentId,g=a.options;c._keyEventStrategy[b](d,e,f,g);}),this[a]=[];}},{key:"_shouldSimulateEventsImmediately",value:function a(){return this._keyEventStrategy.shouldSimulateEventsImmediately()}}]),b}(AbstractKeyEventSimulator);

var FocusTree=function(){function a(){_classCallCheck(this,a),this.id=0;}return _createClass(a,[{key:"isNewerThan",value:function b(a){return this.id!==a}},{key:"new",value:function a(){this.id+=1;}}]),a}();

var EventStrategyLogger=function(a){function b(a,c){var d;return _classCallCheck(this,b),d=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,a)),d._eventStrategy=c,d}return _inherits(b,a),_createClass(b,[{key:"nonKeyEventPrefix",value:function c(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return this.keyEventPrefix(a,_objectSpread({},b,{eventId:!1}))}},{key:"logComponentOptions",value:function c(a,b){this.verbose(this.nonKeyEventPrefix(a),"New component options:\n",function(){return printComponent(b)});}},{key:"logKeyHistory",value:function c(a,b){this.verbose(this.keyEventPrefix(b),function(){return "Key history: ".concat(printComponent(a.toJSON()),".")});}}]),b}(Logger);

var FocusOnlyLogger=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"keyEventPrefix",value:function i(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},d=_get(_getPrototypeOf(b.prototype),"constructor",this).logIcons,e=_get(_getPrototypeOf(b.prototype),"constructor",this).eventIcons,f=_get(_getPrototypeOf(b.prototype),"constructor",this).componentIcons,g="HotKeys (";if(!1!==c.focusTreeId){var j=isUndefined(c.focusTreeId)?this._eventStrategy.focusTreeId:c.focusTreeId;g+="F".concat(j).concat(d[j%d.length],"-");}g+="C".concat(a).concat(f[a%f.length]);var h=this._eventStrategy.componentList.getPositionById(a);if(isUndefined(h)||(g+="-P".concat(h).concat(f[h%f.length])),!1!==c.eventId){var k=isUndefined(c.eventId)?KeyEventCounter.id:c.eventId;g+="-E".concat(k).concat(e[k%e.length]);}return "".concat(g,"):")}},{key:"logIgnoredKeyEvent",value:function f(a,b,c,d,e){this.logIgnoredEvent(describeKeyEvent(a,b,c),d,e);}},{key:"logIgnoredEvent",value:function d(a,b,c){this.debug(this.keyEventPrefix(c),"Ignored ".concat(a," because ").concat(b,"."));}},{key:"logAlreadySimulatedEvent",value:function e(a,b,c,d){this.logIgnoredKeyEvent(a,b,c,"it was not expected, and has already been simulated",d);}}]),b}(EventStrategyLogger);

var FocusOnlyKeyEventStrategy=function(a){function b(){var a,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},d=1<arguments.length?arguments[1]:void 0;return _classCallCheck(this,b),a=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,c,d)),a.logger=new FocusOnlyLogger(c.logLevel||"warn",_assertThisInitialized(_assertThisInitialized(a))),a.eventPropagator.logger=a.logger,a.focusTree=new FocusTree,a._simulator=new FocusOnlyKeyEventSimulator(_assertThisInitialized(_assertThisInitialized(a))),a}return _inherits(b,a),_createClass(b,[{key:"_reset",value:function a(){_get(_getPrototypeOf(b.prototype),"_reset",this).call(this),this._simulator&&this._simulator.clear(),this.focusTree&&this.focusTree.new(),this.eventPropagator=new EventPropagator(this.componentList),this.eventPropagator.logger=this.logger;}},{key:"enableHotKeys",value:function e(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length?arguments[3]:void 0;if(this.resetOnNextFocus&&(this._reset(),this.resetOnNextFocus=!1),!this.componentList.containsId(a))return this._addComponent(a,b,c,"Focused",d),this.focusTree.id}},{key:"updateEnabledHotKeys",value:function f(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},e=4<arguments.length?arguments[4]:void 0;this.focusTree.isNewerThan(a)||!this.componentList.containsId(b)||this._updateComponent(b,c,d,e);}},{key:"disableHotKeys",value:function d(a,b){this.resetOnNextFocus=!0;var c=this.eventPropagator.isPendingPropagation();return c}},{key:"handleKeyDown",value:function f(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},e=getKeyName(a);if(this.focusTree.isNewerThan(b))return this.logger.logIgnoredKeyEvent(a,e,KeyEventType.keydown,"it had an old focus tree id: ".concat(b),c),this.eventPropagator.ignoreEvent(a),!0;if(this._isIgnoringRepeatedEvent(a,e,KeyEventType.keydown,c))return !1;if(this.eventPropagator.startNewPropagationStep(c,a,e,KeyEventType.keydown)){var g=this._howToHandleKeyEvent(a,b,c,e,d,KeyEventType.keydown);g===EventResponse.handled&&(this._recordKeyDown(a,e,c),this._callHandlerIfActionNotHandled(a,e,KeyEventType.keydown,c,b)),this._simulator.handleKeyPressSimulation({event:a,key:e,focusTreeId:b,componentId:c,options:d}),this.eventPropagator.finishPropagationStep();}return !1}},{key:"_howToHandleKeyEvent",value:function g(a,b,c,d,e,f){if(this.eventPropagator.isFirstPropagationStep()){if(e.ignoreEventsCondition(a)&&this.eventPropagator.ignoreEvent(a))return this._eventIsToBeIgnored(a,c,d,f);this.currentCombination.resolveModifierFlagDiscrepancies(a,d,f);}else if(this.eventPropagator.isIgnoringEvent())return this._eventIsToBeIgnored(a,c,d,f);return EventResponse.handled}},{key:"_eventIsToBeIgnored",value:function e(a,b,c,d){return this.logger.logIgnoredKeyEvent(a,c,d,"ignoreEventsFilter rejected it",b),EventResponse.ignored}},{key:"handleKeyPress",value:function g(a,b,c,d){var e=getKeyName(a);if(this._isIgnoringRepeatedEvent(a,e,KeyEventType.keypress,c))return !1;if(this.currentCombination.isKeyPressSimulated(e))return this._ignoreAlreadySimulatedEvent(a,e,KeyEventType.keypress,c),!1;var f=this.focusTree.isNewerThan(b);if(this.eventPropagator.startNewPropagationStep(c,a,e,KeyEventType.keypress)){var h=this._howToHandleKeyEvent(a,b,c,e,d,KeyEventType.keypress);this.eventPropagator.isFirstPropagationStep(c)&&this.currentCombination.isKeyIncluded(e)&&this._recordNewKeyInCombination(e,KeyEventType.keypress,stateFromEvent(a),c),h===EventResponse.handled&&this._callHandlerIfActionNotHandled(a,e,KeyEventType.keypress,c,b),this.eventPropagator.finishPropagationStep();}return f}},{key:"handleKeyUp",value:function h(a,b,c,d){var e=getKeyName(a);if(this.currentCombination.isKeyUpSimulated(e))return this._ignoreAlreadySimulatedEvent(a,e,KeyEventType.keyup,c),!1;var f=this.focusTree.isNewerThan(b),g=this.eventPropagator;if(g.startNewPropagationStep(c,a,e,KeyEventType.keyup)){var i=this._howToHandleKeyEvent(a,b,c,e,d,KeyEventType.keyup);g.isFirstPropagationStep(c)&&this.currentCombination.isKeyIncluded(e)&&this._recordNewKeyInCombination(e,KeyEventType.keyup,stateFromEvent(a),c),i===EventResponse.handled&&this._callHandlerIfActionNotHandled(a,e,KeyEventType.keyup,c,b),this._simulateKeyUpEventsHiddenByCmd(a,e,b,c,d),g.finishPropagationStep();}return f}},{key:"_ignoreAlreadySimulatedEvent",value:function e(a,b,c,d){this.logger.logAlreadySimulatedEvent(a,b,c,d),this.eventPropagator.ignoreEvent(a);}},{key:"closeHangingKeyCombination",value:function d(a,b){var c=this.currentCombination;c.isKeyIncluded(a)&&!c.isEventTriggered(a,b)&&c.setKeyState(a,b,KeyEventState.simulated);}},{key:"_simulateKeyUpEventsHiddenByCmd",value:function g(a,b,c,d,e){var f=this;if(isCmdKey(b)){var h=new KeyCombinationIterator(this.currentCombination);h.forEachKey(function(b){isCmdKey(b)||f._simulator.handleKeyUpSimulation({event:a,key:b,focusTreeId:c,componentId:d,options:e});});}}},{key:"stopEventPropagation",value:function c(a,b){this.eventPropagator.stop(a)&&void 0;}},{key:"simulatePendingKeyPressEvents",value:function a(){this._simulator.simulatePendingKeyPressEvents();}},{key:"simulatePendingKeyUpEvents",value:function a(){this._simulator.simulatePendingKeyUpEvents();}},{key:"shouldSimulateEventsImmediately",value:function a(){return !this.keyEventManager.isGlobalListenersBound()}},{key:"_callHandlerIfActionNotHandled",value:function k(a,b,c,d,e){var f=describeKeyEventType(c),g=this._describeCurrentCombination();if(!this.componentList.anyActionsForEventType(c))return void this.logger.logIgnoredEvent("'".concat(g,"' ").concat(f),"it doesn't have any ".concat(f," handlers"),d);if(this.eventPropagator.isHandled())this.logger.logIgnoredEvent("'".concat(g,"' ").concat(f),"it has already been handled",d);else{var h=this.eventPropagator.previousPosition,i=this.componentList.getPositionById(d),j=this.actionResolver.callClosestMatchingHandler(a,b,c,i,-1===h?0:h);j&&this.eventPropagator.setHandled();}}}]),b}(AbstractKeyEventStrategy);

function findableCollectionContains(a,b,c){return c.stringifyFirst?!isUndefined(a.find(function(a){return a.toString()===b.toString()})):-1!==a.indexOf(b)}function nonCollectionContains(a,b,c){return c.stringifyFirst?a.toString()===b.toString():a===b}function contains(a,b){var c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{};return Array.isArray(a)||isString(a)?findableCollectionContains(a,b,c):isObject(a)?hasKey(a,b):nonCollectionContains(a,b,c)}

var GlobalKeyEventSimulator=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"handleKeyPressSimulation",value:function b(a){this._handleEventSimulation("handleKeyPress",_objectSpread({eventType:KeyEventType.keypress},a));}},{key:"handleKeyUpSimulation",value:function b(a){this._handleEventSimulation("handleKeyUp",_objectSpread({eventType:KeyEventType.keyup},a));}},{key:"_handleEventSimulation",value:function f(a,b){var c=b.event,d=b.eventType,e=b.key;if(this._shouldSimulate(d,e)&&Configuration.option("simulateMissingKeyPressEvents")){var g=this.cloneAndMergeEvent(c,{key:e,simulated:!0});this._keyEventStrategy[a](g);}}}]),b}(AbstractKeyEventSimulator);

function capitalize(a){return a.replace(/\b\w/g,function(a){return a.toUpperCase()})}

function normalizeEventName(a){return "".concat(capitalize(a.slice(0,3))).concat(capitalize(a.slice(3)))}

var GlobalEventListenerAdaptor=function(){function a(b,c){var d=c.logger;_classCallCheck(this,a),this._listenersBound=!1,this.logger=d,this._eventStrategy=b;}return _createClass(a,[{key:"isListenersBound",value:function a(){return this._listenersBound}},{key:"unbindListeners",value:function b(){var a=this;objectValues(KeyEventType).forEach(function(b){var c=describeKeyEventType(b);delete document["on".concat(c)],a._logHandlerStateChange("Removed",c);}),this._listenersBound=!1;}},{key:"bindListeners",value:function b(){var a=this;objectValues(KeyEventType).forEach(function(b){var c=describeKeyEventType(b);document["on".concat(c)]=function(b){a._eventStrategy["handle".concat(normalizeEventName(c))](b);},a._logHandlerStateChange("Bound",c);}),this._listenersBound=!0;}},{key:"_logHandlerStateChange",value:function c(a,b){}}]),a}();

var GlobalLogger=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"keyEventPrefix",value:function h(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},d=_get(_getPrototypeOf(b.prototype),"constructor",this).eventIcons,e=_get(_getPrototypeOf(b.prototype),"constructor",this).componentIcons,f="HotKeys (GLOBAL";if(!isUndefined(a))return "".concat(f,"-C").concat(a).concat(e[a%e.length],"):");if(!1===c.eventId)return "".concat(f,"):");var g=isUndefined(c.eventId)?KeyEventCounter.id:c.eventId;return "".concat(f,"-E").concat(g).concat(d[g%d.length],"):")}},{key:"logIgnoredKeyEvent",value:function f(a,b,c,d,e){this.logIgnoredEvent(describeKeyEvent(a,b,c),d,e);}},{key:"logIgnoredEvent",value:function d(a,b,c){this.debug(this.keyEventPrefix(c),"Ignored ".concat(a," because ").concat(b,"."));}},{key:"logEventRejectedByFilter",value:function e(a,b,c,d){this.logIgnoredKeyEvent(a,b,c,"ignoreEventsFilter rejected it",d);}},{key:"logEventAlreadySimulated",value:function e(a,b,c,d){this.logIgnoredKeyEvent(a,b,c,"it was not expected, and has already been simulated",d);}}]),b}(EventStrategyLogger);

var GlobalKeyEventStrategy=function(a){function b(){var a,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},d=1<arguments.length?arguments[1]:void 0;return _classCallCheck(this,b),a=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,c,d)),a.logger=new GlobalLogger(c.logLevel||"warn",_assertThisInitialized(_assertThisInitialized(a))),a.eventOptions={ignoreEventsCondition:Configuration.option("ignoreEventsCondition")},a.listeners=new Registry,a._simulator=new GlobalKeyEventSimulator(_assertThisInitialized(_assertThisInitialized(a))),a._listenerAdaptor=new GlobalEventListenerAdaptor(_assertThisInitialized(_assertThisInitialized(a)),{logger:a.logger}),a}return _inherits(b,a),_createClass(b,[{key:"enableHotKeys",value:function f(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length?arguments[3]:void 0,e=4<arguments.length?arguments[4]:void 0;this.eventOptions=e,this._addComponent(a,b,c,"Mounted",d);}},{key:"updateEnabledHotKeys",value:function f(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length?arguments[3]:void 0,e=4<arguments.length?arguments[4]:void 0;this.eventOptions=e,this._updateComponent(a,b,c,d);}},{key:"disableHotKeys",value:function b(a){this.componentList.remove(a),this._recalculate();}},{key:"_recalculate",value:function a(){_get(_getPrototypeOf(b.prototype),"_recalculate",this).call(this),this._updateDocumentHandlers();}},{key:"_updateDocumentHandlers",value:function c(){var a=this._shouldListenersBeBound(),b=this.isListenersBound();!b&&a?this._listenerAdaptor.bindListeners():b&&!a&&this._listenerAdaptor.unbindListeners();}},{key:"isListenersBound",value:function a(){return this._listenerAdaptor.isListenersBound()}},{key:"_shouldListenersBeBound",value:function a(){return 0!==this.componentList.length||this.listeners.get("keyCombination")}},{key:"handleKeyDown",value:function d(a){var b=getKeyName(a);if(!this._isIgnoringRepeatedEvent(a,b,KeyEventType.keydown)){this.currentCombination.resolveModifierFlagDiscrepancies(a,b,KeyEventType.keydown);var c=this._howReactAppRespondedTo(a,b,KeyEventType.keydown);return c===EventResponse.unseen&&this.eventOptions.ignoreEventsCondition(a)?void this.logger.logEventRejectedByFilter(a,b,KeyEventType.keydown):void(c!==EventResponse.ignored&&this._recordKeyDown(a,b),this._callHandlerIfNeeded(c,a,b,KeyEventType.keydown),this.keyEventManager.simulatePendingKeyPressEvents(),this._simulator.handleKeyPressSimulation({event:a,key:b}))}}},{key:"_howReactAppRespondedTo",value:function e(a,b,c){var d=this.keyEventManager.reactAppHistoryWithEvent(b,c);return d===EventResponse.handled?this.logger.logIgnoredKeyEvent(a,b,c,"React app has already handled it"):d===EventResponse.ignored?this.logger.logIgnoredKeyEvent(a,b,c,"React app has declared it should be ignored"):d===EventResponse.seen?void 0:(KeyEventCounter.incrementId(),void 0),d}},{key:"handleKeyPress",value:function d(a){var b=getKeyName(a);if(!this._isIgnoringRepeatedEvent(a,b,KeyEventType.keypress)){if(this.currentCombination.isKeyPressSimulated(b))return void this.logger.logEventAlreadySimulated(a,b,KeyEventType.keypress);var c=this._howReactAppRespondedTo(a,b,KeyEventType.keypress);return this.currentCombination.isKeyIncluded(b)&&this._recordNewKeyInCombination(b,KeyEventType.keypress,stateFromEvent(a)),c===EventResponse.unseen&&(this.keyEventManager.closeHangingKeyCombination(b,KeyEventType.keypress),this.eventOptions.ignoreEventsCondition(a))?void this.logger.logEventRejectedByFilter(a,b,KeyEventType.keypress):void this._callHandlerIfNeeded(c,a,b,KeyEventType.keypress)}}},{key:"_callHandlerIfNeeded",value:function e(a,b,c,d){contains([EventResponse.ignored,EventResponse.handled],a)||this._callHandlerIfExists(b,c,d);}},{key:"handleKeyUp",value:function d(a){var b=getKeyName(a);if(this.currentCombination.isKeyUpSimulated(b))return void this.logger.logEventAlreadySimulated(a,b,KeyEventType.keyup);var c=this._howReactAppRespondedTo(a,b,KeyEventType.keyup);this.currentCombination.isKeyIncluded(b)&&this._recordNewKeyInCombination(b,KeyEventType.keyup,stateFromEvent(a)),c===EventResponse.unseen?(this.keyEventManager.closeHangingKeyCombination(b,KeyEventType.keyup),this.eventOptions.ignoreEventsCondition(a)?this.logger.logIgnoredKeyEvent(a,b,KeyEventType.keyup,"ignoreEventsFilter rejected it"):this._callHandlerIfNeeded(c,a,b,KeyEventType.keyup)):this._callHandlerIfNeeded(c,a,b,KeyEventType.keyup),this._simulateKeyUpEventsHiddenByCmd(a,b),this._callKeyCombinationCallbackIfDefined();}},{key:"_simulateKeyUpEventsHiddenByCmd",value:function d(a,b){var c=this;if(isCmdKey(b)){this.keyEventManager.simulatePendingKeyUpEvents();var e=new KeyCombinationIterator(this.currentCombination);e.forEachKey(function(b){isCmdKey(b)||c._simulator.handleKeyUpSimulation({event:a,key:b});});}}},{key:"_callKeyCombinationCallbackIfDefined",value:function a(){if(this.listeners.get("keyCombination")&&this.currentCombination.hasEnded()){var b=new KeyCombinationDecorator(this.currentCombination);this.listeners.get("keyCombination")({keys:b.asKeyDictionary(),id:b.describe()});}}},{key:"_callHandlerIfExists",value:function f(a,b,c){var d=describeKeyEventType(c),e=this._describeCurrentCombination();return this.componentList.anyActionsForEventType(c)?void(this._callClosestMatchingHandler(a,b,c)):void this.logger.logIgnoredEvent("'".concat(e,"' ").concat(d),"it doesn't have any ".concat(d," handlers"))}},{key:"_callClosestMatchingHandler",value:function d(a,b,c){for(var e,f=this.componentList.iterator;f.next();)if(e=this.actionResolver.callClosestMatchingHandler(a,b,c,f.position,0),e)return void void 0}},{key:"stopEventPropagation",value:function c(a,b){a.simulated||a.stopPropagation();}},{key:"addKeyCombinationListener",value:function d(a){var b=this,c=function(){b.listeners.remove("keyCombination");};return this.listeners.set("keyCombination",function(b){a(b),c();}),this._updateDocumentHandlers(),c}}]),b}(AbstractKeyEventStrategy);

function copyAttributes(a,b,c){return c.forEach(function(c){hasKey(a,c)&&(b[c]=a[c]);}),b}

var SEQUENCE_ATTRIBUTES=["sequence","action"],KEYMAP_ATTRIBUTES=["name","description","group"];function createSequenceFromConfig(a){return arrayFrom(a).map(function(a){return isObject(a)?copyAttributes(a,{},SEQUENCE_ATTRIBUTES):{sequence:a}})}function normalizeActionDefinition(a,b,c){var d=a[b];c[b]={},isObject(d)?hasKey(d,"sequences")?(copyAttributes(d,c[b],KEYMAP_ATTRIBUTES),c[b].sequences=createSequenceFromConfig(d.sequences)):(copyAttributes(d,c[b],KEYMAP_ATTRIBUTES),c[b].sequences=[copyAttributes(d,{},SEQUENCE_ATTRIBUTES)]):c[b].sequences=createSequenceFromConfig(d);}var ApplicationKeyMapBuilder=function(){function a(b){_classCallCheck(this,a),this._componentTree=b;}return _createClass(a,[{key:"build",value:function a(){return this._componentTree.hasRoot()?this._build([this._componentTree.rootId],{}):{}}},{key:"_build",value:function d(a,b){var c=this;return a.forEach(function(a){var d=c._componentTree.get(a),e=d.childIds,f=d.keyMap;f&&Object.keys(f).forEach(function(a){normalizeActionDefinition(f,a,b);}),c._build(e,b);}),b}}]),a}();

var KeyEventManager=function(){function a(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,a);var c=Configuration.option("logLevel");this.logger=b.logger||new Logger(c),this.focusOnlyEventStrategy=new FocusOnlyKeyEventStrategy({configuration:b,logLevel:c},this),this.globalEventStrategy=new GlobalKeyEventStrategy({configuration:b,logLevel:c},this),this.mountedComponentsCount=0,this._blurHandler=this._clearKeyHistory.bind(this);}return _createClass(a,null,[{key:"getInstance",value:function c(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return lazyLoadAttribute(this,"instance",function(){return new a(b)})}},{key:"getFocusOnlyEventStrategy",value:function a(){return this.getInstance().focusOnlyEventStrategy}},{key:"getGlobalEventStrategy",value:function a(){return this.getInstance().globalEventStrategy}}]),_createClass(a,[{key:"registerComponentMount",value:function c(a,b){return this._incrementComponentCount(),this.focusOnlyEventStrategy.registerComponentMount(a,b)}},{key:"registerComponentUnmount",value:function a(){this._decrementComponentCount();}},{key:"_incrementComponentCount",value:function b(){var a=this.mountedComponentsCount;this.mountedComponentsCount+=1,0===a&&1===this.mountedComponentsCount&&window.addEventListener("blur",this._blurHandler);}},{key:"_decrementComponentCount",value:function b(){var a=this.mountedComponentsCount;this.mountedComponentsCount-=1,1===a&&0===this.mountedComponentsCount&&window.removeEventListener("blur",this._blurHandler);}},{key:"_clearKeyHistory",value:function a(){this.focusOnlyEventStrategy.resetKeyHistory({force:!0}),this.globalEventStrategy.resetKeyHistory({force:!0});}},{key:"registerGlobalComponentUnmount",value:function a(){this._decrementComponentCount();}},{key:"registerGlobalComponentMount",value:function c(a,b){return this._incrementComponentCount(),this.globalEventStrategy.registerComponentMount(a,b)}},{key:"addKeyCombinationListener",value:function b(a){return this.globalEventStrategy.addKeyCombinationListener(a)}},{key:"ignoreEvent",value:function b(a){this.focusOnlyEventStrategy.eventPropagator.ignoreEvent(a);}},{key:"observeIgnoredEvents",value:function b(a){this.focusOnlyEventStrategy.eventPropagator.observeIgnoredEvents(a);}},{key:"closeHangingKeyCombination",value:function c(a,b){this.focusOnlyEventStrategy.closeHangingKeyCombination(a,b);}},{key:"reactAppHistoryWithEvent",value:function d(a,b){var c=this.focusOnlyEventStrategy.eventPropagator.previousPropagation;return c.isForKey(a)&&c.isForEventType(b)?c.isHandled()?EventResponse.handled:c.isIgnoringEvent()?EventResponse.ignored:EventResponse.seen:EventResponse.unseen}},{key:"simulatePendingKeyPressEvents",value:function a(){this.focusOnlyEventStrategy.simulatePendingKeyPressEvents();}},{key:"simulatePendingKeyUpEvents",value:function a(){this.focusOnlyEventStrategy.simulatePendingKeyUpEvents();}},{key:"isGlobalListenersBound",value:function a(){return this.globalEventStrategy.isListenersBound()}},{key:"applicationKeyMap",get:function a(){return [this.globalEventStrategy,this.focusOnlyEventStrategy].reduce(function(a,b){var c=new ApplicationKeyMapBuilder(b.componentTree),d=c.build();return _objectSpread({},a,d)},{})}}]),a}();

function wrapPropInFunction(a,b){return "function"==typeof a?function(c){a(c),b(c);}:b}function getComponentOptions(){return {defaultKeyEvent:Configuration.option("defaultKeyEvent")}}function getEventOptions(){return {ignoreEventsCondition:Configuration.option("ignoreEventsCondition")}}var FocusOnlyComponentManager=function(){function a(b,c){var d=c.keyMap;_classCallCheck(this,a),this._hotKeysOptions=b,this.id=KeyEventManager.getFocusOnlyEventStrategy().registerKeyMap(d),this.childContext={hotKeysParentId:this.id},this._focusTreeIds=[];}return _createClass(a,[{key:"getComponentProps",value:function d(a){var b=this,c={onFocus:wrapPropInFunction(a.onFocus,function(){return b.enableHotKeys(a)}),onBlur:wrapPropInFunction(a.onBlur,function(){return b.disableHotKeys(a)}),tabIndex:Configuration.option("defaultTabIndex")};return this._shouldBindKeyListeners(a)&&(c.onKeyDown=function(a){return b._delegateEventToManager(a,"handleKeyDown")},c.onKeyPress=function(a){return b._delegateEventToManager(a,"handleKeyPress")},c.onKeyUp=function(a){return b._delegateEventToManager(a,"handleKeyUp")}),c}},{key:"_shouldBindKeyListeners",value:function c(a){var b=this._getKeyMap(a);return !isEmpty(b)||a.root}},{key:"addHotKeys",value:function c(a){var b=KeyEventManager.getInstance();b.registerComponentMount(this.id,a);}},{key:"enableHotKeys",value:function c(a){a.onFocus&&a.onFocus.apply(a,arguments);var b=KeyEventManager.getFocusOnlyEventStrategy().enableHotKeys(this.id,this._getKeyMap(a),this._getHandlers(a),getComponentOptions());isUndefined(b)||this._focusTreeIdsPush(b),this._setFocused(!0);}},{key:"updateHotKeys",value:function e(a){var b=KeyEventManager.getFocusOnlyEventStrategy();if(b.reregisterKeyMap(this.id,a.keyMap),this._componentIsFocused()&&(a.allowChanges||!Configuration.option("ignoreKeymapAndHandlerChangesByDefault"))){var c=a.keyMap,d=a.handlers;b.updateEnabledHotKeys(this.focusTreeId,this.id,c,d,getComponentOptions());}}},{key:"disableHotKeys",value:function c(a){a.onBlur&&a.onBlur.apply(a,arguments);var b=KeyEventManager.getFocusOnlyEventStrategy().disableHotKeys(this.focusTreeId,this.id);b||this._focusTreeIdsShift(),this._setFocused(!1);}},{key:"removeKeyMap",value:function c(a){var b=KeyEventManager.getFocusOnlyEventStrategy();b.deregisterKeyMap(this.id),KeyEventManager.getInstance().registerComponentUnmount(),this.disableHotKeys(a);}},{key:"_componentIsFocused",value:function a(){return !0===this._focused}},{key:"_focusTreeIdsPush",value:function b(a){this._focusTreeIds.push(a);}},{key:"_focusTreeIdsShift",value:function a(){this._focusTreeIds.shift();}},{key:"_setFocused",value:function b(a){this._focused=a;}},{key:"_delegateEventToManager",value:function d(a,b){var c=KeyEventManager.getFocusOnlyEventStrategy()[b](a,this.focusTreeId,this.id,getEventOptions());c&&this._focusTreeIdsShift();}},{key:"_mergeWithOptions",value:function c(a,b){return _objectSpread({},this._hotKeysOptions[a]||{},b[a]||{})}},{key:"_getHandlers",value:function b(a){return this._mergeWithOptions("handlers",a)}},{key:"_getKeyMap",value:function b(a){return this._mergeWithOptions("keyMap",a)}},{key:"focusTreeId",get:function a(){return this._focusTreeIds[0]}}]),a}();

var propTypes={keyMap:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),handlers:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),onFocus:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),onBlur:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),allowChanges:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),root:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)};function provideWithContext(a){return backwardsCompatibleContext(a,{deprecatedAPI:{contextTypes:{hotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)},childContextTypes:{hotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)}},newAPI:{contextType:{hotKeysParentId:void 0}}})}function componentFactory(a){var b,c,d=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{};return c=b=function(b){function c(a){var b;return _classCallCheck(this,c),b=_possibleConstructorReturn(this,_getPrototypeOf(c).call(this,a)),b._manager=new FocusOnlyComponentManager(d,a),b}return _inherits(c,b),_createClass(c,[{key:"componentDidMount",value:function a(){this._manager.addHotKeys(this.context.hotKeysParentId);}},{key:"componentDidUpdate",value:function a(){this._manager.updateHotKeys(this.props);}},{key:"componentWillUnmount",value:function a(){this._manager.removeKeyMap(this.props);}},{key:"render",value:function h(){var b=this.props,c=b.keyMap,d=b.handlers,e=b.allowChanges,f=b.root,g=_objectWithoutProperties(b,["keyMap","handlers","allowChanges","root"]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(a,_extends({hotKeys:this._manager.getComponentProps(this.props)},g))}}]),c}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent),_defineProperty(b,"propTypes",propTypes),c}function withHotKeys(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{};return provideWithContext(componentFactory(a,b))}

var HotKeysWrapper=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"render",value:function g(){var a=this.props,b=a.hotKeys,c=a.innerRef,d=a.component,e=_objectWithoutProperties(a,["hotKeys","innerRef","component"]),f=d||Configuration.option("defaultComponent");return react__WEBPACK_IMPORTED_MODULE_0__.createElement(f,_objectSpread({},b,{ref:c},e))}}]),b}(react__WEBPACK_IMPORTED_MODULE_0__.Component),HotKeys=withHotKeys(HotKeysWrapper);HotKeys.propTypes={innerRef:prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)])};

var GlobalComponentManager=function(){function a(b){_classCallCheck(this,a),this.id=KeyEventManager.getGlobalEventStrategy().registerKeyMap(b),this.childContext={globalHotKeysParentId:this.id};}return _createClass(a,null,[{key:"_getComponentOptions",value:function a(){return {defaultKeyEvent:Configuration.option("defaultKeyEvent")}}},{key:"_getEventOptions",value:function a(){return {ignoreEventsCondition:Configuration.option("ignoreEventsCondition")}}}]),_createClass(a,[{key:"addHotKeys",value:function g(b,c){var d=b.keyMap,e=b.handlers,f=c.globalHotKeysParentId;KeyEventManager.getInstance().registerGlobalComponentMount(this.id,f),KeyEventManager.getGlobalEventStrategy().enableHotKeys(this.id,d,e,a._getComponentOptions(),a._getEventOptions());}},{key:"updateHotKeys",value:function f(b){var c=KeyEventManager.getGlobalEventStrategy();if(c.reregisterKeyMap(this.id,b.keyMap),b.allowChanges||!Configuration.option("ignoreKeymapAndHandlerChangesByDefault")){var d=b.keyMap,e=b.handlers;c.updateEnabledHotKeys(this.id,d,e,a._getComponentOptions(),a._getEventOptions());}}},{key:"removeKeyMap",value:function b(){var a=KeyEventManager.getGlobalEventStrategy();a.deregisterKeyMap(this.id),a.disableHotKeys(this.id),KeyEventManager.getInstance().registerGlobalComponentUnmount();}}]),a}();

var GlobalHotKeys=function(a){function b(a){var c;return _classCallCheck(this,b),c=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,a)),c._manager=new GlobalComponentManager(a.keyMap),c}return _inherits(b,a),_createClass(b,[{key:"render",value:function a(){return this.props.children||null}},{key:"componentDidMount",value:function a(){this._manager.addHotKeys(this.props,this.context);}},{key:"componentDidUpdate",value:function a(){this._manager.updateHotKeys(this.props);}},{key:"componentWillUnmount",value:function a(){this._manager.removeKeyMap();}}]),b}(react__WEBPACK_IMPORTED_MODULE_0__.Component);_defineProperty(GlobalHotKeys,"propTypes",{keyMap:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),handlers:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),allowChanges:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)});var GlobalHotKeys$1 = backwardsCompatibleContext(GlobalHotKeys,{deprecatedAPI:{contextTypes:{globalHotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)},childContextTypes:{globalHotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)}},newAPI:{contextType:{globalHotKeysParentId:void 0}}});

var HotKeysIgnoreOverrideManager=function(){function a(b){_classCallCheck(this,a),this._handleKeyEvent=this._handleKeyEvent.bind(this),this._eventManagerMethod=b;}return _createClass(a,[{key:"getComponentProps",value:function c(a){var b=this;return {onKeyDown:this._handleKeyEvent,onKeyPress:this._handleKeyEvent,onKeyUp:this._handleKeyEvent,onFocus:function c(){return b._reloadDictionaries(a())}}}},{key:"_reloadDictionaries",value:function d(a){var b=a.only,c=a.except;this._onlyDict=keyDictionary(b),this._exceptDict=keyDictionary(c);}},{key:"_handleKeyEvent",value:function b(a){this._shouldIgnoreEvent(a)&&KeyEventManager.getInstance()[this._eventManagerMethod](a);}},{key:"_shouldIgnoreEvent",value:function c(a){var b=a.key;return isEmpty(this._onlyDict)?!!isEmpty(this._exceptDict)||!hasKey(this._exceptDict,b):isEmpty(this._exceptDict)?hasKey(this._onlyDict,b):hasKey(this._onlyDict,b)&&!hasKey(this._exceptDict,b)}}]),a}();function keyDictionary(a){return arrayFrom(a).reduce(function(a,b){var c=standardizeKeyName(b);if(!isValidKey(c))throw new InvalidKeyNameError(b);return dictionaryFrom([resolveAltShiftedAlias,resolveUnaltShiftedAlias,resolveShiftedAlias,resolveUnshiftedAlias,resolveAltedAlias,resolveUnaltedAlias],!0,function(a){return a(c)},a),a},{})}

var propTypes$1={only:prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_1___default().string))]),except:prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_1___default().string))])};function withHotKeysIgnoreOverride(a){var b,c,d=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{only:[],except:[]},e=2<arguments.length?arguments[2]:void 0;return c=b=function(b){function c(a){var b;return _classCallCheck(this,c),b=_possibleConstructorReturn(this,_getPrototypeOf(c).call(this,a)),b._manager=new HotKeysIgnoreOverrideManager(e),b}return _inherits(c,b),_createClass(c,[{key:"render",value:function g(){var b=this,c=this.props,d=c.only,e=c.except,f=_objectWithoutProperties(c,["only","except"]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(a,_extends({hotKeys:this._manager.getComponentProps(function(){return b.props})},f))}}]),c}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent),_defineProperty(b,"propTypes",propTypes$1),_defineProperty(b,"defaultProps",d),c}

function overrideComponent(a){var b,c;return c=b=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"render",value:function e(){var a=this.props,b=a.hotKeys,c=_objectWithoutProperties(a,["hotKeys"]),d=c.component||Configuration.option("defaultComponent");return react__WEBPACK_IMPORTED_MODULE_0__.createElement(d,_objectSpread({},b,c))}}]),b}(react__WEBPACK_IMPORTED_MODULE_0__.Component),_defineProperty(b,"displayName",a),c}

var IgnoreKeys = withHotKeysIgnoreOverride(overrideComponent("IgnoreKeys"),{},"ignoreEvent");

var ObserveKeys = withHotKeysIgnoreOverride(overrideComponent("ObserveKeys"),{},"observeIgnoredEvents");

function withIgnoreKeys(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{only:[],except:[]};return withHotKeysIgnoreOverride(a,b,"ignoreEvent")}

function withObserveKeys(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{only:[],except:[]};return withHotKeysIgnoreOverride(a,b,"observeIgnoredEvents")}

function configure(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{};Configuration.init(a);}

function getApplicationKeyMap(){return KeyEventManager.getInstance().applicationKeyMap}

function recordKeyCombination(a){var b=KeyEventManager.getInstance();return b.addKeyCombinationListener(a)}




/***/ }),

/***/ 26722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(4534);
} else {}


/***/ }),

/***/ 81779:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  yF: () => (/* binding */ UIDConsumer),
  Ot: () => (/* binding */ UIDReset)
});

// UNUSED EXPORTS: UIDFork

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/context.js + 1 modules
var context = __webpack_require__(65619);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/UIDComponent.js



// --------------------------------------------
var prefixId = function (id, prefix, name) {
    var uid = (prefix + id);
    return String(name ? name(uid) : uid);
};
/**
 * @deprecated
 * UID in form of renderProps (not SSR friendly)
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UID>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UID>
 *
 * // get uid to generate uid for a keys in a list
 * <UID>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UID>
 */
var UID = /** @class */ (function (_super) {
    __extends(UID, _super);
    function UID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            quartz: _this.props.idSource || context/* counter */.cL,
            prefix: (0,context/* getPrefix */.Gn)(_this.props.idSource),
            id: (0,context/* getId */.zv)(_this.props.idSource || context/* counter */.cL)
        };
        _this.uid = function (item) { return prefixId(_this.state.id + '-' + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name); };
        return _this;
    }
    UID.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name;
        var _b = this.state, id = _b.id, prefix = _b.prefix;
        return children(prefixId(id, prefix, name), this.uid);
    };
    return UID;
}(react.Component));


;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/Control.js



/**
 * UID isolation component, required for SSR and testing.
 * Wrap your application with it to guarantee UID consistency between SSR and CSR.
 * @param {String} [prefix] - prefix for all generated ids
 * @example
 * <UIDReset>
 *    <App />
 * </UIDReset/>
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 */
var UIDReset = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (react.createElement(context/* source */.qz.Provider, { value: (0,context/* createSource */._P)(prefix) }, children));
};
/**
 * Creates a sub-ids for nested components, isolating from inside a branch.
 * Useful for self-contained elements or code splitting
 * @see https://github.com/thearnica/react-uid#code-splitting
 */
var UIDFork = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (React.createElement(UIDConsumer, null, function (id) { return (React.createElement(source.Provider, { value: createSource(id + '-' + prefix) }, children)); }));
};
/**
 * UID in form of renderProps. Supports nesting and SSR. Prefer {@link useUID} hook version if possible.
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UIDConsumer>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UIDConsumer>
 *
 * // get uid to generate uid for a keys in a list
 * <UIDConsumer>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UIDConsumer>
 *
 * @see {@link useUID} - a hook version of this component
 * @see {@link UID} - not SSR compatible version
 */
var UIDConsumer = function (_a) {
    var name = _a.name, children = _a.children;
    return (react.createElement(context/* source */.qz.Consumer, null, function (value) { return (react.createElement(UID, { name: name, idSource: value, children: children })); }));
};


/***/ }),

/***/ 65619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  cL: () => (/* binding */ counter),
  _P: () => (/* binding */ createSource),
  zv: () => (/* binding */ getId),
  Gn: () => (/* binding */ getPrefix),
  qz: () => (/* binding */ source)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/uid.js
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */
var generateUID = function () {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */
    var uid = function (item, index) {
        if (typeof item === 'number' ||
            typeof item === 'string') {
            return index ? "idx-" + index : "val-" + item;
        }
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
/**
 * @name uid
 * returns an UID associated with {item}
 * @param {Object} item - object to generate UID for
 * @param {Number} index, a fallback index
 * @example
 * uid(object) == 1;
 * uid(object) == 1;
 * uid(anotherObject) == 2;
 * uid("not object", 42) == 42
 *
 * @see {@link useUID}
 */
var uid = generateUID();

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/context.js


var createSource = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return ({
        value: 1,
        prefix: prefix,
        uid: generateUID()
    });
};
var counter = createSource();
var source = react.createContext(createSource());
var getId = function (source) { return source.value++; };
var getPrefix = function (source) { return source ? source.prefix : ''; };


/***/ }),

/***/ 29303:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(30242);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 82348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(29303);
} else {}


/***/ })

}]);